"use strict";
// tslint:disable
/**
 * Unimaze\'s Workflow web api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var globalImportUrl = __importStar(require("url"));
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var CreateComplaintMessageThreadActionTypeEnum;
(function (CreateComplaintMessageThreadActionTypeEnum) {
    CreateComplaintMessageThreadActionTypeEnum["DisputeInvoice"] = "DisputeInvoice";
    CreateComplaintMessageThreadActionTypeEnum["DisputeCreditNote"] = "DisputeCreditNote";
    CreateComplaintMessageThreadActionTypeEnum["DisputeOrder"] = "DisputeOrder";
})(CreateComplaintMessageThreadActionTypeEnum = exports.CreateComplaintMessageThreadActionTypeEnum || (exports.CreateComplaintMessageThreadActionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreateComplaintMessageThreadDocumentTypeEnum;
(function (CreateComplaintMessageThreadDocumentTypeEnum) {
    CreateComplaintMessageThreadDocumentTypeEnum["Invoice"] = "Invoice";
    CreateComplaintMessageThreadDocumentTypeEnum["CreditNote"] = "CreditNote";
    CreateComplaintMessageThreadDocumentTypeEnum["Order"] = "Order";
    CreateComplaintMessageThreadDocumentTypeEnum["RemittanceAdvice"] = "RemittanceAdvice";
    CreateComplaintMessageThreadDocumentTypeEnum["Unspecified"] = "Unspecified";
})(CreateComplaintMessageThreadDocumentTypeEnum = exports.CreateComplaintMessageThreadDocumentTypeEnum || (exports.CreateComplaintMessageThreadDocumentTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DocumentDetailOutputDocumentTypeEnum;
(function (DocumentDetailOutputDocumentTypeEnum) {
    DocumentDetailOutputDocumentTypeEnum["Invoice"] = "Invoice";
    DocumentDetailOutputDocumentTypeEnum["CreditNote"] = "CreditNote";
    DocumentDetailOutputDocumentTypeEnum["Order"] = "Order";
    DocumentDetailOutputDocumentTypeEnum["RemittanceAdvice"] = "RemittanceAdvice";
    DocumentDetailOutputDocumentTypeEnum["Unspecified"] = "Unspecified";
})(DocumentDetailOutputDocumentTypeEnum = exports.DocumentDetailOutputDocumentTypeEnum || (exports.DocumentDetailOutputDocumentTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DocumentOutputDirectionEnum;
(function (DocumentOutputDirectionEnum) {
    DocumentOutputDirectionEnum["Inbound"] = "Inbound";
    DocumentOutputDirectionEnum["Outbound"] = "Outbound";
})(DocumentOutputDirectionEnum = exports.DocumentOutputDirectionEnum || (exports.DocumentOutputDirectionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DocumentOutputDocumentTypeEnum;
(function (DocumentOutputDocumentTypeEnum) {
    DocumentOutputDocumentTypeEnum["Invoice"] = "Invoice";
    DocumentOutputDocumentTypeEnum["CreditNote"] = "CreditNote";
    DocumentOutputDocumentTypeEnum["Order"] = "Order";
    DocumentOutputDocumentTypeEnum["RemittanceAdvice"] = "RemittanceAdvice";
    DocumentOutputDocumentTypeEnum["Unspecified"] = "Unspecified";
})(DocumentOutputDocumentTypeEnum = exports.DocumentOutputDocumentTypeEnum || (exports.DocumentOutputDocumentTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DocumentOutputStatusEnum;
(function (DocumentOutputStatusEnum) {
    DocumentOutputStatusEnum["New"] = "New";
    DocumentOutputStatusEnum["Pending"] = "Pending";
    DocumentOutputStatusEnum["Processed"] = "Processed";
    DocumentOutputStatusEnum["Failed"] = "Failed";
    DocumentOutputStatusEnum["None"] = "None";
})(DocumentOutputStatusEnum = exports.DocumentOutputStatusEnum || (exports.DocumentOutputStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var HttpResponseMessageStatusCodeEnum;
(function (HttpResponseMessageStatusCodeEnum) {
    HttpResponseMessageStatusCodeEnum["Continue"] = "Continue";
    HttpResponseMessageStatusCodeEnum["SwitchingProtocols"] = "SwitchingProtocols";
    HttpResponseMessageStatusCodeEnum["OK"] = "OK";
    HttpResponseMessageStatusCodeEnum["Created"] = "Created";
    HttpResponseMessageStatusCodeEnum["Accepted"] = "Accepted";
    HttpResponseMessageStatusCodeEnum["NonAuthoritativeInformation"] = "NonAuthoritativeInformation";
    HttpResponseMessageStatusCodeEnum["NoContent"] = "NoContent";
    HttpResponseMessageStatusCodeEnum["ResetContent"] = "ResetContent";
    HttpResponseMessageStatusCodeEnum["PartialContent"] = "PartialContent";
    HttpResponseMessageStatusCodeEnum["MultipleChoices"] = "MultipleChoices";
    HttpResponseMessageStatusCodeEnum["Ambiguous"] = "Ambiguous";
    HttpResponseMessageStatusCodeEnum["MovedPermanently"] = "MovedPermanently";
    HttpResponseMessageStatusCodeEnum["Moved"] = "Moved";
    HttpResponseMessageStatusCodeEnum["Found"] = "Found";
    HttpResponseMessageStatusCodeEnum["Redirect"] = "Redirect";
    HttpResponseMessageStatusCodeEnum["SeeOther"] = "SeeOther";
    HttpResponseMessageStatusCodeEnum["RedirectMethod"] = "RedirectMethod";
    HttpResponseMessageStatusCodeEnum["NotModified"] = "NotModified";
    HttpResponseMessageStatusCodeEnum["UseProxy"] = "UseProxy";
    HttpResponseMessageStatusCodeEnum["Unused"] = "Unused";
    HttpResponseMessageStatusCodeEnum["TemporaryRedirect"] = "TemporaryRedirect";
    HttpResponseMessageStatusCodeEnum["RedirectKeepVerb"] = "RedirectKeepVerb";
    HttpResponseMessageStatusCodeEnum["BadRequest"] = "BadRequest";
    HttpResponseMessageStatusCodeEnum["Unauthorized"] = "Unauthorized";
    HttpResponseMessageStatusCodeEnum["PaymentRequired"] = "PaymentRequired";
    HttpResponseMessageStatusCodeEnum["Forbidden"] = "Forbidden";
    HttpResponseMessageStatusCodeEnum["NotFound"] = "NotFound";
    HttpResponseMessageStatusCodeEnum["MethodNotAllowed"] = "MethodNotAllowed";
    HttpResponseMessageStatusCodeEnum["NotAcceptable"] = "NotAcceptable";
    HttpResponseMessageStatusCodeEnum["ProxyAuthenticationRequired"] = "ProxyAuthenticationRequired";
    HttpResponseMessageStatusCodeEnum["RequestTimeout"] = "RequestTimeout";
    HttpResponseMessageStatusCodeEnum["Conflict"] = "Conflict";
    HttpResponseMessageStatusCodeEnum["Gone"] = "Gone";
    HttpResponseMessageStatusCodeEnum["LengthRequired"] = "LengthRequired";
    HttpResponseMessageStatusCodeEnum["PreconditionFailed"] = "PreconditionFailed";
    HttpResponseMessageStatusCodeEnum["RequestEntityTooLarge"] = "RequestEntityTooLarge";
    HttpResponseMessageStatusCodeEnum["RequestUriTooLong"] = "RequestUriTooLong";
    HttpResponseMessageStatusCodeEnum["UnsupportedMediaType"] = "UnsupportedMediaType";
    HttpResponseMessageStatusCodeEnum["RequestedRangeNotSatisfiable"] = "RequestedRangeNotSatisfiable";
    HttpResponseMessageStatusCodeEnum["ExpectationFailed"] = "ExpectationFailed";
    HttpResponseMessageStatusCodeEnum["UpgradeRequired"] = "UpgradeRequired";
    HttpResponseMessageStatusCodeEnum["InternalServerError"] = "InternalServerError";
    HttpResponseMessageStatusCodeEnum["NotImplemented"] = "NotImplemented";
    HttpResponseMessageStatusCodeEnum["BadGateway"] = "BadGateway";
    HttpResponseMessageStatusCodeEnum["ServiceUnavailable"] = "ServiceUnavailable";
    HttpResponseMessageStatusCodeEnum["GatewayTimeout"] = "GatewayTimeout";
    HttpResponseMessageStatusCodeEnum["HttpVersionNotSupported"] = "HttpVersionNotSupported";
})(HttpResponseMessageStatusCodeEnum = exports.HttpResponseMessageStatusCodeEnum || (exports.HttpResponseMessageStatusCodeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MessageThreadOutputActionTypeEnum;
(function (MessageThreadOutputActionTypeEnum) {
    MessageThreadOutputActionTypeEnum["DisputeInvoice"] = "DisputeInvoice";
    MessageThreadOutputActionTypeEnum["DisputeCreditNote"] = "DisputeCreditNote";
    MessageThreadOutputActionTypeEnum["DisputeOrder"] = "DisputeOrder";
})(MessageThreadOutputActionTypeEnum = exports.MessageThreadOutputActionTypeEnum || (exports.MessageThreadOutputActionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MessageThreadOutputDocumentTypeEnum;
(function (MessageThreadOutputDocumentTypeEnum) {
    MessageThreadOutputDocumentTypeEnum["Invoice"] = "Invoice";
    MessageThreadOutputDocumentTypeEnum["CreditNote"] = "CreditNote";
    MessageThreadOutputDocumentTypeEnum["Order"] = "Order";
    MessageThreadOutputDocumentTypeEnum["RemittanceAdvice"] = "RemittanceAdvice";
    MessageThreadOutputDocumentTypeEnum["Unspecified"] = "Unspecified";
})(MessageThreadOutputDocumentTypeEnum = exports.MessageThreadOutputDocumentTypeEnum || (exports.MessageThreadOutputDocumentTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MessageThreadRelatedDocumentResourceThreadActionEnum;
(function (MessageThreadRelatedDocumentResourceThreadActionEnum) {
    MessageThreadRelatedDocumentResourceThreadActionEnum["DisputeInvoice"] = "DisputeInvoice";
    MessageThreadRelatedDocumentResourceThreadActionEnum["DisputeCreditNote"] = "DisputeCreditNote";
    MessageThreadRelatedDocumentResourceThreadActionEnum["DisputeOrder"] = "DisputeOrder";
})(MessageThreadRelatedDocumentResourceThreadActionEnum = exports.MessageThreadRelatedDocumentResourceThreadActionEnum || (exports.MessageThreadRelatedDocumentResourceThreadActionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var NotificationSettingsResourceThreadCreatedEnum;
(function (NotificationSettingsResourceThreadCreatedEnum) {
    NotificationSettingsResourceThreadCreatedEnum["Immediately"] = "Immediately";
    NotificationSettingsResourceThreadCreatedEnum["NeverNotify"] = "NeverNotify";
})(NotificationSettingsResourceThreadCreatedEnum = exports.NotificationSettingsResourceThreadCreatedEnum || (exports.NotificationSettingsResourceThreadCreatedEnum = {}));
/**
    * @export
    * @enum {string}
    */
var NotificationSettingsResourceThreadReplyTypeEnum;
(function (NotificationSettingsResourceThreadReplyTypeEnum) {
    NotificationSettingsResourceThreadReplyTypeEnum["Immediately"] = "Immediately";
    NotificationSettingsResourceThreadReplyTypeEnum["NeverNotify"] = "NeverNotify";
    NotificationSettingsResourceThreadReplyTypeEnum["Delayed"] = "Delayed";
})(NotificationSettingsResourceThreadReplyTypeEnum = exports.NotificationSettingsResourceThreadReplyTypeEnum || (exports.NotificationSettingsResourceThreadReplyTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ParticipantCapabilityOutputDocumentTypeEnum;
(function (ParticipantCapabilityOutputDocumentTypeEnum) {
    ParticipantCapabilityOutputDocumentTypeEnum["Invoice"] = "Invoice";
    ParticipantCapabilityOutputDocumentTypeEnum["CreditNote"] = "CreditNote";
    ParticipantCapabilityOutputDocumentTypeEnum["Order"] = "Order";
    ParticipantCapabilityOutputDocumentTypeEnum["RemittanceAdvice"] = "RemittanceAdvice";
    ParticipantCapabilityOutputDocumentTypeEnum["Unspecified"] = "Unspecified";
})(ParticipantCapabilityOutputDocumentTypeEnum = exports.ParticipantCapabilityOutputDocumentTypeEnum || (exports.ParticipantCapabilityOutputDocumentTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var RecipeHeaderResDocumentTypeEnum;
(function (RecipeHeaderResDocumentTypeEnum) {
    RecipeHeaderResDocumentTypeEnum["Invoice"] = "Invoice";
    RecipeHeaderResDocumentTypeEnum["CreditNote"] = "CreditNote";
    RecipeHeaderResDocumentTypeEnum["Order"] = "Order";
    RecipeHeaderResDocumentTypeEnum["RemittanceAdvice"] = "RemittanceAdvice";
    RecipeHeaderResDocumentTypeEnum["Unspecified"] = "Unspecified";
})(RecipeHeaderResDocumentTypeEnum = exports.RecipeHeaderResDocumentTypeEnum || (exports.RecipeHeaderResDocumentTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var RecipeSearchOptionsActionsEnum;
(function (RecipeSearchOptionsActionsEnum) {
    RecipeSearchOptionsActionsEnum["NotSet"] = "NotSet";
    RecipeSearchOptionsActionsEnum["SubmitInvoice"] = "SubmitInvoice";
    RecipeSearchOptionsActionsEnum["CorrectWithCredit"] = "CorrectWithCredit";
    RecipeSearchOptionsActionsEnum["SubmitOrder"] = "SubmitOrder";
})(RecipeSearchOptionsActionsEnum = exports.RecipeSearchOptionsActionsEnum || (exports.RecipeSearchOptionsActionsEnum = {}));
/**
    * @export
    * @enum {string}
    */
var RecipeSearchOptionsStatusesEnum;
(function (RecipeSearchOptionsStatusesEnum) {
    RecipeSearchOptionsStatusesEnum["Pending"] = "Pending";
    RecipeSearchOptionsStatusesEnum["Ready"] = "Ready";
    RecipeSearchOptionsStatusesEnum["Imported"] = "Imported";
})(RecipeSearchOptionsStatusesEnum = exports.RecipeSearchOptionsStatusesEnum || (exports.RecipeSearchOptionsStatusesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var RelatedDocumentOutputDocumentTypeEnum;
(function (RelatedDocumentOutputDocumentTypeEnum) {
    RelatedDocumentOutputDocumentTypeEnum["Invoice"] = "Invoice";
    RelatedDocumentOutputDocumentTypeEnum["CreditNote"] = "CreditNote";
    RelatedDocumentOutputDocumentTypeEnum["Order"] = "Order";
    RelatedDocumentOutputDocumentTypeEnum["RemittanceAdvice"] = "RemittanceAdvice";
    RelatedDocumentOutputDocumentTypeEnum["Unspecified"] = "Unspecified";
})(RelatedDocumentOutputDocumentTypeEnum = exports.RelatedDocumentOutputDocumentTypeEnum || (exports.RelatedDocumentOutputDocumentTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var RequirementGroupInputOperandEnum;
(function (RequirementGroupInputOperandEnum) {
    RequirementGroupInputOperandEnum["And"] = "And";
    RequirementGroupInputOperandEnum["Or"] = "Or";
})(RequirementGroupInputOperandEnum = exports.RequirementGroupInputOperandEnum || (exports.RequirementGroupInputOperandEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ThreadAdvancedSearchOptionsMessageThreadStatusEnum;
(function (ThreadAdvancedSearchOptionsMessageThreadStatusEnum) {
    ThreadAdvancedSearchOptionsMessageThreadStatusEnum["All"] = "All";
    ThreadAdvancedSearchOptionsMessageThreadStatusEnum["Active"] = "Active";
    ThreadAdvancedSearchOptionsMessageThreadStatusEnum["NotResponded"] = "NotResponded";
    ThreadAdvancedSearchOptionsMessageThreadStatusEnum["Closed"] = "Closed";
})(ThreadAdvancedSearchOptionsMessageThreadStatusEnum = exports.ThreadAdvancedSearchOptionsMessageThreadStatusEnum || (exports.ThreadAdvancedSearchOptionsMessageThreadStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ThreadAdvancedSearchOptionsMessageThreadDirectionEnum;
(function (ThreadAdvancedSearchOptionsMessageThreadDirectionEnum) {
    ThreadAdvancedSearchOptionsMessageThreadDirectionEnum["IncomingRequest"] = "IncomingRequest";
    ThreadAdvancedSearchOptionsMessageThreadDirectionEnum["OutgoingQuery"] = "OutgoingQuery";
})(ThreadAdvancedSearchOptionsMessageThreadDirectionEnum = exports.ThreadAdvancedSearchOptionsMessageThreadDirectionEnum || (exports.ThreadAdvancedSearchOptionsMessageThreadDirectionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ThreadAdvancedSearchOptionsDocumentTypeEnum;
(function (ThreadAdvancedSearchOptionsDocumentTypeEnum) {
    ThreadAdvancedSearchOptionsDocumentTypeEnum["Invoice"] = "Invoice";
    ThreadAdvancedSearchOptionsDocumentTypeEnum["CreditNote"] = "CreditNote";
    ThreadAdvancedSearchOptionsDocumentTypeEnum["Order"] = "Order";
    ThreadAdvancedSearchOptionsDocumentTypeEnum["RemittanceAdvice"] = "RemittanceAdvice";
    ThreadAdvancedSearchOptionsDocumentTypeEnum["Unspecified"] = "Unspecified";
})(ThreadAdvancedSearchOptionsDocumentTypeEnum = exports.ThreadAdvancedSearchOptionsDocumentTypeEnum || (exports.ThreadAdvancedSearchOptionsDocumentTypeEnum = {}));
/**
 * ApplicationApi - axios parameter creator
 * @export
 */
exports.ApplicationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returning application initialization settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationInitGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/application/init";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ApplicationApi - functional programming interface
 * @export
 */
exports.ApplicationApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Returning application initialization settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationInitGet: function (options) {
            var localVarAxiosArgs = exports.ApplicationApiAxiosParamCreator(configuration).apiV1ApplicationInitGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ApplicationApi - factory interface
 * @export
 */
exports.ApplicationApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Returning application initialization settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationInitGet: function (options) {
            return exports.ApplicationApiFp(configuration).apiV1ApplicationInitGet(options)(axios, basePath);
        },
    };
};
/**
 * ApplicationApi - object-oriented interface
 * @export
 * @class ApplicationApi
 * @extends {BaseAPI}
 */
var ApplicationApi = /** @class */ (function (_super) {
    __extends(ApplicationApi, _super);
    function ApplicationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Returning application initialization settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    ApplicationApi.prototype.apiV1ApplicationInitGet = function (options) {
        return exports.ApplicationApiFp(this.configuration).apiV1ApplicationInitGet(options)(this.axios, this.basePath);
    };
    return ApplicationApi;
}(base_1.BaseAPI));
exports.ApplicationApi = ApplicationApi;
/**
 * CompaniesApi - axios parameter creator
 * @export
 */
exports.CompaniesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get customer companies by name for a company
         * @param {string} legalIsoIdentifier
         * @param {string} [nameFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesByLegalIsoIdentifierCustomersbynameGet: function (legalIsoIdentifier, nameFilter, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'legalIsoIdentifier' is not null or undefined
            if (legalIsoIdentifier === null || legalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier', 'Required parameter legalIsoIdentifier was null or undefined when calling apiV1CompaniesByLegalIsoIdentifierCustomersbynameGet.');
            }
            var localVarPath = "/api/v1/companies/{legalIsoIdentifier}/customersbyname"
                .replace("{" + "legalIsoIdentifier" + "}", encodeURIComponent(String(legalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (nameFilter !== undefined) {
                localVarQueryParameter['nameFilter'] = nameFilter;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returning list of threads.
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesByLegalIsoIdentifierGet: function (legalIsoIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'legalIsoIdentifier' is not null or undefined
            if (legalIsoIdentifier === null || legalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier', 'Required parameter legalIsoIdentifier was null or undefined when calling apiV1CompaniesByLegalIsoIdentifierGet.');
            }
            var localVarPath = "/api/v1/companies/{legalIsoIdentifier}"
                .replace("{" + "legalIsoIdentifier" + "}", encodeURIComponent(String(legalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesCustomersannouncementcontactsGet: function (textFilter, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/companies/customersannouncementcontacts";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (textFilter !== undefined) {
                localVarQueryParameter['textFilter'] = textFilter;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get customer companies by tag for a company
         * @param {string} [tag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesCustomersbytagGet: function (tag, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/companies/customersbytag";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Look up for companies
         * @param {string} [name]
         * @param {string} [registrationNumber]
         * @param {string} [address]
         * @param {string} [country]
         * @param {string} [textFilter]
         * @param {boolean} [onlyWithIsoIdentifier]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesGet: function (name, registrationNumber, address, country, textFilter, onlyWithIsoIdentifier, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/companies";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }
            if (registrationNumber !== undefined) {
                localVarQueryParameter['RegistrationNumber'] = registrationNumber;
            }
            if (address !== undefined) {
                localVarQueryParameter['Address'] = address;
            }
            if (country !== undefined) {
                localVarQueryParameter['Country'] = country;
            }
            if (textFilter !== undefined) {
                localVarQueryParameter['TextFilter'] = textFilter;
            }
            if (onlyWithIsoIdentifier !== undefined) {
                localVarQueryParameter['OnlyWithIsoIdentifier'] = onlyWithIsoIdentifier;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {'Customer' | 'Supplier'} [profileTagRoleTypeKey]
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesProfiletagsGet: function (profileTagRoleTypeKey, textFilter, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/companies/profiletags";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (profileTagRoleTypeKey !== undefined) {
                localVarQueryParameter['profileTagRoleTypeKey'] = profileTagRoleTypeKey;
            }
            if (textFilter !== undefined) {
                localVarQueryParameter['textFilter'] = textFilter;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesSuppliersannouncementcontactsGet: function (textFilter, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/companies/suppliersannouncementcontacts";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (textFilter !== undefined) {
                localVarQueryParameter['textFilter'] = textFilter;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get supplier companies by tag for a company
         * @param {string} [tag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesSuppliersbytagGet: function (tag, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/companies/suppliersbytag";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get customer company tags for a company - WAS: companies/{legalIsoIdentifier}/tags?customerlegalisoidentifier=0196:5504033150
         * @param {string} customerLegalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByCustomerLegalIsoIdentifierTagsGet: function (customerLegalIsoIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'customerLegalIsoIdentifier' is not null or undefined
            if (customerLegalIsoIdentifier === null || customerLegalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('customerLegalIsoIdentifier', 'Required parameter customerLegalIsoIdentifier was null or undefined when calling apiV1CustomersByCustomerLegalIsoIdentifierTagsGet.');
            }
            var localVarPath = "/api/v1/customers/{customerLegalIsoIdentifier}/tags"
                .replace("{" + "customerLegalIsoIdentifier" + "}", encodeURIComponent(String(customerLegalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Assign multiple customer tags for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags/multi
         * @param {string} customerLegalIsoIdentifier
         * @param {CustomerCompanyTags} [customerCompanyTags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByCustomerLegalIsoIdentifierTagsPost: function (customerLegalIsoIdentifier, customerCompanyTags, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'customerLegalIsoIdentifier' is not null or undefined
            if (customerLegalIsoIdentifier === null || customerLegalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('customerLegalIsoIdentifier', 'Required parameter customerLegalIsoIdentifier was null or undefined when calling apiV1CustomersByCustomerLegalIsoIdentifierTagsPost.');
            }
            var localVarPath = "/api/v1/customers/{customerLegalIsoIdentifier}/tags"
                .replace("{" + "customerLegalIsoIdentifier" + "}", encodeURIComponent(String(customerLegalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof customerCompanyTags !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(customerCompanyTags !== undefined ? customerCompanyTags : {}) : (customerCompanyTags || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Submit announcement: WAS: api/v1/companies/{legalIsoIdentifier}/announcement
         * @param {SubmitAnnouncement} [submitAnnouncement]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersSubmitAnnouncementPost: function (submitAnnouncement, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/customers/submit-announcement";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof submitAnnouncement !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(submitAnnouncement !== undefined ? submitAnnouncement : {}) : (submitAnnouncement || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete customer company tag for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags?tag=testcomp
         * @param {string} [tag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersTagsDelete: function (tag, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/customers/tags";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all customer company tags for a company - WAS: companies/{legalIsoIdentifier}/tags/all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersTagsGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/customers/tags";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByLegalIsoIdentifierSettingsGet: function (legalIsoIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'legalIsoIdentifier' is not null or undefined
            if (legalIsoIdentifier === null || legalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier', 'Required parameter legalIsoIdentifier was null or undefined when calling apiV1ProfilesByLegalIsoIdentifierSettingsGet.');
            }
            var localVarPath = "/api/v1/profiles/{legalIsoIdentifier}/settings"
                .replace("{" + "legalIsoIdentifier" + "}", encodeURIComponent(String(legalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsGet: function (legalIsoIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'legalIsoIdentifier' is not null or undefined
            if (legalIsoIdentifier === null || legalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier', 'Required parameter legalIsoIdentifier was null or undefined when calling apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsGet.');
            }
            var localVarPath = "/api/v1/profiles/{legalIsoIdentifier}/settings/notifications"
                .replace("{" + "legalIsoIdentifier" + "}", encodeURIComponent(String(legalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} legalIsoIdentifier
         * @param {NotificationSettingsRes} [notificationSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsPut: function (legalIsoIdentifier, notificationSettings, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'legalIsoIdentifier' is not null or undefined
            if (legalIsoIdentifier === null || legalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier', 'Required parameter legalIsoIdentifier was null or undefined when calling apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsPut.');
            }
            var localVarPath = "/api/v1/profiles/{legalIsoIdentifier}/settings/notifications"
                .replace("{" + "legalIsoIdentifier" + "}", encodeURIComponent(String(legalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof notificationSettings !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(notificationSettings !== undefined ? notificationSettings : {}) : (notificationSettings || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Deletes a profile.  - WAS: api/Companies/0196:5504033150
         * @param {string} [legalIsoIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesDelete: function (legalIsoIdentifier, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/profiles";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (legalIsoIdentifier !== undefined) {
                localVarQueryParameter['legalIsoIdentifier'] = legalIsoIdentifier;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Creates a profile - WAS: api/Companies
         * @param {string} [legalIsoIdentifier]
         * @param {ProfileData} [profileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesPost: function (legalIsoIdentifier, profileData, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/profiles";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (legalIsoIdentifier !== undefined) {
                localVarQueryParameter['legalIsoIdentifier'] = legalIsoIdentifier;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof profileData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(profileData !== undefined ? profileData : {}) : (profileData || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Updates a profile - WAS: api/Companies/0196:5504033150
         * @param {ProfileData} [profileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesPut: function (profileData, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/profiles";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof profileData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(profileData !== undefined ? profileData : {}) : (profileData || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get supplier company tags for a company - WAS: companies/{legalIsoIdentifier}/tags?customerlegalisoidentifier=0196:5504033150
         * @param {string} supplierLegalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersBySupplierLegalIsoIdentifierTagsGet: function (supplierLegalIsoIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'supplierLegalIsoIdentifier' is not null or undefined
            if (supplierLegalIsoIdentifier === null || supplierLegalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('supplierLegalIsoIdentifier', 'Required parameter supplierLegalIsoIdentifier was null or undefined when calling apiV1SuppliersBySupplierLegalIsoIdentifierTagsGet.');
            }
            var localVarPath = "/api/v1/suppliers/{supplierLegalIsoIdentifier}/tags"
                .replace("{" + "supplierLegalIsoIdentifier" + "}", encodeURIComponent(String(supplierLegalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Assign multiple supplier tags for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags/multi
         * @param {string} supplierLegalIsoIdentifier
         * @param {CustomerCompanyTags} [supplierCompanyTags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersBySupplierLegalIsoIdentifierTagsPost: function (supplierLegalIsoIdentifier, supplierCompanyTags, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'supplierLegalIsoIdentifier' is not null or undefined
            if (supplierLegalIsoIdentifier === null || supplierLegalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('supplierLegalIsoIdentifier', 'Required parameter supplierLegalIsoIdentifier was null or undefined when calling apiV1SuppliersBySupplierLegalIsoIdentifierTagsPost.');
            }
            var localVarPath = "/api/v1/suppliers/{supplierLegalIsoIdentifier}/tags"
                .replace("{" + "supplierLegalIsoIdentifier" + "}", encodeURIComponent(String(supplierLegalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof supplierCompanyTags !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(supplierCompanyTags !== undefined ? supplierCompanyTags : {}) : (supplierCompanyTags || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete supplier company tag for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags?tag=testcomp
         * @param {string} [tag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersTagsDelete: function (tag, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/suppliers/tags";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all supplier company tags for a company - WAS: companies/{legalIsoIdentifier}/tags/all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersTagsGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/suppliers/tags";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CompaniesApi - functional programming interface
 * @export
 */
exports.CompaniesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get customer companies by name for a company
         * @param {string} legalIsoIdentifier
         * @param {string} [nameFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesByLegalIsoIdentifierCustomersbynameGet: function (legalIsoIdentifier, nameFilter, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1CompaniesByLegalIsoIdentifierCustomersbynameGet(legalIsoIdentifier, nameFilter, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returning list of threads.
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesByLegalIsoIdentifierGet: function (legalIsoIdentifier, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1CompaniesByLegalIsoIdentifierGet(legalIsoIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesCustomersannouncementcontactsGet: function (textFilter, offset, limit, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1CompaniesCustomersannouncementcontactsGet(textFilter, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get customer companies by tag for a company
         * @param {string} [tag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesCustomersbytagGet: function (tag, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1CompaniesCustomersbytagGet(tag, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Look up for companies
         * @param {string} [name]
         * @param {string} [registrationNumber]
         * @param {string} [address]
         * @param {string} [country]
         * @param {string} [textFilter]
         * @param {boolean} [onlyWithIsoIdentifier]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesGet: function (name, registrationNumber, address, country, textFilter, onlyWithIsoIdentifier, offset, limit, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1CompaniesGet(name, registrationNumber, address, country, textFilter, onlyWithIsoIdentifier, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {'Customer' | 'Supplier'} [profileTagRoleTypeKey]
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesProfiletagsGet: function (profileTagRoleTypeKey, textFilter, offset, limit, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1CompaniesProfiletagsGet(profileTagRoleTypeKey, textFilter, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesSuppliersannouncementcontactsGet: function (textFilter, offset, limit, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1CompaniesSuppliersannouncementcontactsGet(textFilter, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get supplier companies by tag for a company
         * @param {string} [tag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesSuppliersbytagGet: function (tag, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1CompaniesSuppliersbytagGet(tag, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get customer company tags for a company - WAS: companies/{legalIsoIdentifier}/tags?customerlegalisoidentifier=0196:5504033150
         * @param {string} customerLegalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByCustomerLegalIsoIdentifierTagsGet: function (customerLegalIsoIdentifier, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1CustomersByCustomerLegalIsoIdentifierTagsGet(customerLegalIsoIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Assign multiple customer tags for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags/multi
         * @param {string} customerLegalIsoIdentifier
         * @param {CustomerCompanyTags} [customerCompanyTags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByCustomerLegalIsoIdentifierTagsPost: function (customerLegalIsoIdentifier, customerCompanyTags, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1CustomersByCustomerLegalIsoIdentifierTagsPost(customerLegalIsoIdentifier, customerCompanyTags, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Submit announcement: WAS: api/v1/companies/{legalIsoIdentifier}/announcement
         * @param {SubmitAnnouncement} [submitAnnouncement]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersSubmitAnnouncementPost: function (submitAnnouncement, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1CustomersSubmitAnnouncementPost(submitAnnouncement, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Delete customer company tag for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags?tag=testcomp
         * @param {string} [tag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersTagsDelete: function (tag, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1CustomersTagsDelete(tag, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all customer company tags for a company - WAS: companies/{legalIsoIdentifier}/tags/all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersTagsGet: function (options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1CustomersTagsGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByLegalIsoIdentifierSettingsGet: function (legalIsoIdentifier, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1ProfilesByLegalIsoIdentifierSettingsGet(legalIsoIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsGet: function (legalIsoIdentifier, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsGet(legalIsoIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} legalIsoIdentifier
         * @param {NotificationSettingsRes} [notificationSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsPut: function (legalIsoIdentifier, notificationSettings, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsPut(legalIsoIdentifier, notificationSettings, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Deletes a profile.  - WAS: api/Companies/0196:5504033150
         * @param {string} [legalIsoIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesDelete: function (legalIsoIdentifier, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1ProfilesDelete(legalIsoIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Creates a profile - WAS: api/Companies
         * @param {string} [legalIsoIdentifier]
         * @param {ProfileData} [profileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesPost: function (legalIsoIdentifier, profileData, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1ProfilesPost(legalIsoIdentifier, profileData, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Updates a profile - WAS: api/Companies/0196:5504033150
         * @param {ProfileData} [profileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesPut: function (profileData, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1ProfilesPut(profileData, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get supplier company tags for a company - WAS: companies/{legalIsoIdentifier}/tags?customerlegalisoidentifier=0196:5504033150
         * @param {string} supplierLegalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersBySupplierLegalIsoIdentifierTagsGet: function (supplierLegalIsoIdentifier, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1SuppliersBySupplierLegalIsoIdentifierTagsGet(supplierLegalIsoIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Assign multiple supplier tags for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags/multi
         * @param {string} supplierLegalIsoIdentifier
         * @param {CustomerCompanyTags} [supplierCompanyTags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersBySupplierLegalIsoIdentifierTagsPost: function (supplierLegalIsoIdentifier, supplierCompanyTags, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1SuppliersBySupplierLegalIsoIdentifierTagsPost(supplierLegalIsoIdentifier, supplierCompanyTags, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Delete supplier company tag for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags?tag=testcomp
         * @param {string} [tag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersTagsDelete: function (tag, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1SuppliersTagsDelete(tag, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all supplier company tags for a company - WAS: companies/{legalIsoIdentifier}/tags/all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersTagsGet: function (options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).apiV1SuppliersTagsGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * CompaniesApi - factory interface
 * @export
 */
exports.CompaniesApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Get customer companies by name for a company
         * @param {string} legalIsoIdentifier
         * @param {string} [nameFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesByLegalIsoIdentifierCustomersbynameGet: function (legalIsoIdentifier, nameFilter, options) {
            return exports.CompaniesApiFp(configuration).apiV1CompaniesByLegalIsoIdentifierCustomersbynameGet(legalIsoIdentifier, nameFilter, options)(axios, basePath);
        },
        /**
         *
         * @summary Returning list of threads.
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesByLegalIsoIdentifierGet: function (legalIsoIdentifier, options) {
            return exports.CompaniesApiFp(configuration).apiV1CompaniesByLegalIsoIdentifierGet(legalIsoIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesCustomersannouncementcontactsGet: function (textFilter, offset, limit, options) {
            return exports.CompaniesApiFp(configuration).apiV1CompaniesCustomersannouncementcontactsGet(textFilter, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @summary Get customer companies by tag for a company
         * @param {string} [tag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesCustomersbytagGet: function (tag, options) {
            return exports.CompaniesApiFp(configuration).apiV1CompaniesCustomersbytagGet(tag, options)(axios, basePath);
        },
        /**
         *
         * @summary Look up for companies
         * @param {string} [name]
         * @param {string} [registrationNumber]
         * @param {string} [address]
         * @param {string} [country]
         * @param {string} [textFilter]
         * @param {boolean} [onlyWithIsoIdentifier]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesGet: function (name, registrationNumber, address, country, textFilter, onlyWithIsoIdentifier, offset, limit, options) {
            return exports.CompaniesApiFp(configuration).apiV1CompaniesGet(name, registrationNumber, address, country, textFilter, onlyWithIsoIdentifier, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @param {'Customer' | 'Supplier'} [profileTagRoleTypeKey]
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesProfiletagsGet: function (profileTagRoleTypeKey, textFilter, offset, limit, options) {
            return exports.CompaniesApiFp(configuration).apiV1CompaniesProfiletagsGet(profileTagRoleTypeKey, textFilter, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesSuppliersannouncementcontactsGet: function (textFilter, offset, limit, options) {
            return exports.CompaniesApiFp(configuration).apiV1CompaniesSuppliersannouncementcontactsGet(textFilter, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @summary Get supplier companies by tag for a company
         * @param {string} [tag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompaniesSuppliersbytagGet: function (tag, options) {
            return exports.CompaniesApiFp(configuration).apiV1CompaniesSuppliersbytagGet(tag, options)(axios, basePath);
        },
        /**
         *
         * @summary Get customer company tags for a company - WAS: companies/{legalIsoIdentifier}/tags?customerlegalisoidentifier=0196:5504033150
         * @param {string} customerLegalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByCustomerLegalIsoIdentifierTagsGet: function (customerLegalIsoIdentifier, options) {
            return exports.CompaniesApiFp(configuration).apiV1CustomersByCustomerLegalIsoIdentifierTagsGet(customerLegalIsoIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @summary Assign multiple customer tags for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags/multi
         * @param {string} customerLegalIsoIdentifier
         * @param {CustomerCompanyTags} [customerCompanyTags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByCustomerLegalIsoIdentifierTagsPost: function (customerLegalIsoIdentifier, customerCompanyTags, options) {
            return exports.CompaniesApiFp(configuration).apiV1CustomersByCustomerLegalIsoIdentifierTagsPost(customerLegalIsoIdentifier, customerCompanyTags, options)(axios, basePath);
        },
        /**
         *
         * @summary Submit announcement: WAS: api/v1/companies/{legalIsoIdentifier}/announcement
         * @param {SubmitAnnouncement} [submitAnnouncement]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersSubmitAnnouncementPost: function (submitAnnouncement, options) {
            return exports.CompaniesApiFp(configuration).apiV1CustomersSubmitAnnouncementPost(submitAnnouncement, options)(axios, basePath);
        },
        /**
         *
         * @summary Delete customer company tag for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags?tag=testcomp
         * @param {string} [tag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersTagsDelete: function (tag, options) {
            return exports.CompaniesApiFp(configuration).apiV1CustomersTagsDelete(tag, options)(axios, basePath);
        },
        /**
         *
         * @summary Get all customer company tags for a company - WAS: companies/{legalIsoIdentifier}/tags/all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersTagsGet: function (options) {
            return exports.CompaniesApiFp(configuration).apiV1CustomersTagsGet(options)(axios, basePath);
        },
        /**
         *
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByLegalIsoIdentifierSettingsGet: function (legalIsoIdentifier, options) {
            return exports.CompaniesApiFp(configuration).apiV1ProfilesByLegalIsoIdentifierSettingsGet(legalIsoIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsGet: function (legalIsoIdentifier, options) {
            return exports.CompaniesApiFp(configuration).apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsGet(legalIsoIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @param {string} legalIsoIdentifier
         * @param {NotificationSettingsRes} [notificationSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsPut: function (legalIsoIdentifier, notificationSettings, options) {
            return exports.CompaniesApiFp(configuration).apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsPut(legalIsoIdentifier, notificationSettings, options)(axios, basePath);
        },
        /**
         *
         * @summary Deletes a profile.  - WAS: api/Companies/0196:5504033150
         * @param {string} [legalIsoIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesDelete: function (legalIsoIdentifier, options) {
            return exports.CompaniesApiFp(configuration).apiV1ProfilesDelete(legalIsoIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @summary Creates a profile - WAS: api/Companies
         * @param {string} [legalIsoIdentifier]
         * @param {ProfileData} [profileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesPost: function (legalIsoIdentifier, profileData, options) {
            return exports.CompaniesApiFp(configuration).apiV1ProfilesPost(legalIsoIdentifier, profileData, options)(axios, basePath);
        },
        /**
         *
         * @summary Updates a profile - WAS: api/Companies/0196:5504033150
         * @param {ProfileData} [profileData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesPut: function (profileData, options) {
            return exports.CompaniesApiFp(configuration).apiV1ProfilesPut(profileData, options)(axios, basePath);
        },
        /**
         *
         * @summary Get supplier company tags for a company - WAS: companies/{legalIsoIdentifier}/tags?customerlegalisoidentifier=0196:5504033150
         * @param {string} supplierLegalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersBySupplierLegalIsoIdentifierTagsGet: function (supplierLegalIsoIdentifier, options) {
            return exports.CompaniesApiFp(configuration).apiV1SuppliersBySupplierLegalIsoIdentifierTagsGet(supplierLegalIsoIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @summary Assign multiple supplier tags for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags/multi
         * @param {string} supplierLegalIsoIdentifier
         * @param {CustomerCompanyTags} [supplierCompanyTags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersBySupplierLegalIsoIdentifierTagsPost: function (supplierLegalIsoIdentifier, supplierCompanyTags, options) {
            return exports.CompaniesApiFp(configuration).apiV1SuppliersBySupplierLegalIsoIdentifierTagsPost(supplierLegalIsoIdentifier, supplierCompanyTags, options)(axios, basePath);
        },
        /**
         *
         * @summary Delete supplier company tag for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags?tag=testcomp
         * @param {string} [tag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersTagsDelete: function (tag, options) {
            return exports.CompaniesApiFp(configuration).apiV1SuppliersTagsDelete(tag, options)(axios, basePath);
        },
        /**
         *
         * @summary Get all supplier company tags for a company - WAS: companies/{legalIsoIdentifier}/tags/all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersTagsGet: function (options) {
            return exports.CompaniesApiFp(configuration).apiV1SuppliersTagsGet(options)(axios, basePath);
        },
    };
};
/**
 * CompaniesApi - object-oriented interface
 * @export
 * @class CompaniesApi
 * @extends {BaseAPI}
 */
var CompaniesApi = /** @class */ (function (_super) {
    __extends(CompaniesApi, _super);
    function CompaniesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get customer companies by name for a company
     * @param {string} legalIsoIdentifier
     * @param {string} [nameFilter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1CompaniesByLegalIsoIdentifierCustomersbynameGet = function (legalIsoIdentifier, nameFilter, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1CompaniesByLegalIsoIdentifierCustomersbynameGet(legalIsoIdentifier, nameFilter, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returning list of threads.
     * @param {string} legalIsoIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1CompaniesByLegalIsoIdentifierGet = function (legalIsoIdentifier, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1CompaniesByLegalIsoIdentifierGet(legalIsoIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} [textFilter]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1CompaniesCustomersannouncementcontactsGet = function (textFilter, offset, limit, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1CompaniesCustomersannouncementcontactsGet(textFilter, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get customer companies by tag for a company
     * @param {string} [tag]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1CompaniesCustomersbytagGet = function (tag, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1CompaniesCustomersbytagGet(tag, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Look up for companies
     * @param {string} [name]
     * @param {string} [registrationNumber]
     * @param {string} [address]
     * @param {string} [country]
     * @param {string} [textFilter]
     * @param {boolean} [onlyWithIsoIdentifier]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1CompaniesGet = function (name, registrationNumber, address, country, textFilter, onlyWithIsoIdentifier, offset, limit, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1CompaniesGet(name, registrationNumber, address, country, textFilter, onlyWithIsoIdentifier, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {'Customer' | 'Supplier'} [profileTagRoleTypeKey]
     * @param {string} [textFilter]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1CompaniesProfiletagsGet = function (profileTagRoleTypeKey, textFilter, offset, limit, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1CompaniesProfiletagsGet(profileTagRoleTypeKey, textFilter, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} [textFilter]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1CompaniesSuppliersannouncementcontactsGet = function (textFilter, offset, limit, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1CompaniesSuppliersannouncementcontactsGet(textFilter, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get supplier companies by tag for a company
     * @param {string} [tag]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1CompaniesSuppliersbytagGet = function (tag, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1CompaniesSuppliersbytagGet(tag, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get customer company tags for a company - WAS: companies/{legalIsoIdentifier}/tags?customerlegalisoidentifier=0196:5504033150
     * @param {string} customerLegalIsoIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1CustomersByCustomerLegalIsoIdentifierTagsGet = function (customerLegalIsoIdentifier, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1CustomersByCustomerLegalIsoIdentifierTagsGet(customerLegalIsoIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Assign multiple customer tags for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags/multi
     * @param {string} customerLegalIsoIdentifier
     * @param {CustomerCompanyTags} [customerCompanyTags]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1CustomersByCustomerLegalIsoIdentifierTagsPost = function (customerLegalIsoIdentifier, customerCompanyTags, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1CustomersByCustomerLegalIsoIdentifierTagsPost(customerLegalIsoIdentifier, customerCompanyTags, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Submit announcement: WAS: api/v1/companies/{legalIsoIdentifier}/announcement
     * @param {SubmitAnnouncement} [submitAnnouncement]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1CustomersSubmitAnnouncementPost = function (submitAnnouncement, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1CustomersSubmitAnnouncementPost(submitAnnouncement, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Delete customer company tag for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags?tag=testcomp
     * @param {string} [tag]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1CustomersTagsDelete = function (tag, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1CustomersTagsDelete(tag, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get all customer company tags for a company - WAS: companies/{legalIsoIdentifier}/tags/all
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1CustomersTagsGet = function (options) {
        return exports.CompaniesApiFp(this.configuration).apiV1CustomersTagsGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} legalIsoIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1ProfilesByLegalIsoIdentifierSettingsGet = function (legalIsoIdentifier, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1ProfilesByLegalIsoIdentifierSettingsGet(legalIsoIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} legalIsoIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsGet = function (legalIsoIdentifier, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsGet(legalIsoIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} legalIsoIdentifier
     * @param {NotificationSettingsRes} [notificationSettings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsPut = function (legalIsoIdentifier, notificationSettings, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1ProfilesByLegalIsoIdentifierSettingsNotificationsPut(legalIsoIdentifier, notificationSettings, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Deletes a profile.  - WAS: api/Companies/0196:5504033150
     * @param {string} [legalIsoIdentifier]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1ProfilesDelete = function (legalIsoIdentifier, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1ProfilesDelete(legalIsoIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Creates a profile - WAS: api/Companies
     * @param {string} [legalIsoIdentifier]
     * @param {ProfileData} [profileData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1ProfilesPost = function (legalIsoIdentifier, profileData, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1ProfilesPost(legalIsoIdentifier, profileData, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Updates a profile - WAS: api/Companies/0196:5504033150
     * @param {ProfileData} [profileData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1ProfilesPut = function (profileData, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1ProfilesPut(profileData, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get supplier company tags for a company - WAS: companies/{legalIsoIdentifier}/tags?customerlegalisoidentifier=0196:5504033150
     * @param {string} supplierLegalIsoIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1SuppliersBySupplierLegalIsoIdentifierTagsGet = function (supplierLegalIsoIdentifier, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1SuppliersBySupplierLegalIsoIdentifierTagsGet(supplierLegalIsoIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Assign multiple supplier tags for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags/multi
     * @param {string} supplierLegalIsoIdentifier
     * @param {CustomerCompanyTags} [supplierCompanyTags]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1SuppliersBySupplierLegalIsoIdentifierTagsPost = function (supplierLegalIsoIdentifier, supplierCompanyTags, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1SuppliersBySupplierLegalIsoIdentifierTagsPost(supplierLegalIsoIdentifier, supplierCompanyTags, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Delete supplier company tag for a company - WAS: api/v1/companies/{legalIsoIdentifier}/tags?tag=testcomp
     * @param {string} [tag]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1SuppliersTagsDelete = function (tag, options) {
        return exports.CompaniesApiFp(this.configuration).apiV1SuppliersTagsDelete(tag, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get all supplier company tags for a company - WAS: companies/{legalIsoIdentifier}/tags/all
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.apiV1SuppliersTagsGet = function (options) {
        return exports.CompaniesApiFp(this.configuration).apiV1SuppliersTagsGet(options)(this.axios, this.basePath);
    };
    return CompaniesApi;
}(base_1.BaseAPI));
exports.CompaniesApi = CompaniesApi;
/**
 * DashboardApi - axios parameter creator
 * @export
 */
exports.DashboardApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardNotificationsGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/dashboard/notifications";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {'Day' | 'Month' | 'Quarter' | 'Year'} granularity
         * @param {Date} [from]
         * @param {Date} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardSummaryGet: function (granularity, from, to, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'granularity' is not null or undefined
            if (granularity === null || granularity === undefined) {
                throw new base_1.RequiredError('granularity', 'Required parameter granularity was null or undefined when calling apiV1DashboardSummaryGet.');
            }
            var localVarPath = "/api/v1/dashboard/summary";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (granularity !== undefined) {
                localVarQueryParameter['Granularity'] = granularity;
            }
            if (from !== undefined) {
                localVarQueryParameter['From'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['To'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DashboardApi - functional programming interface
 * @export
 */
exports.DashboardApiFp = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardNotificationsGet: function (options) {
            var localVarAxiosArgs = exports.DashboardApiAxiosParamCreator(configuration).apiV1DashboardNotificationsGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {'Day' | 'Month' | 'Quarter' | 'Year'} granularity
         * @param {Date} [from]
         * @param {Date} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardSummaryGet: function (granularity, from, to, options) {
            var localVarAxiosArgs = exports.DashboardApiAxiosParamCreator(configuration).apiV1DashboardSummaryGet(granularity, from, to, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * DashboardApi - factory interface
 * @export
 */
exports.DashboardApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardNotificationsGet: function (options) {
            return exports.DashboardApiFp(configuration).apiV1DashboardNotificationsGet(options)(axios, basePath);
        },
        /**
         *
         * @param {'Day' | 'Month' | 'Quarter' | 'Year'} granularity
         * @param {Date} [from]
         * @param {Date} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardSummaryGet: function (granularity, from, to, options) {
            return exports.DashboardApiFp(configuration).apiV1DashboardSummaryGet(granularity, from, to, options)(axios, basePath);
        },
    };
};
/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
var DashboardApi = /** @class */ (function (_super) {
    __extends(DashboardApi, _super);
    function DashboardApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    DashboardApi.prototype.apiV1DashboardNotificationsGet = function (options) {
        return exports.DashboardApiFp(this.configuration).apiV1DashboardNotificationsGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {'Day' | 'Month' | 'Quarter' | 'Year'} granularity
     * @param {Date} [from]
     * @param {Date} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    DashboardApi.prototype.apiV1DashboardSummaryGet = function (granularity, from, to, options) {
        return exports.DashboardApiFp(this.configuration).apiV1DashboardSummaryGet(granularity, from, to, options)(this.axios, this.basePath);
    };
    return DashboardApi;
}(base_1.BaseAPI));
exports.DashboardApi = DashboardApi;
/**
 * DocumentApi - axios parameter creator
 * @export
 */
exports.DocumentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Binaries will be streamed directly from payload if payload exists or from remote resource accessible via link.  <br />  Document reference have to belong to specified transfer id; there are checks for this returning error response if this is not the case.
         * @param {string} transferId Document transfer guid
         * @param {number} documentReferenceId Document reference id
         * @param {string} [lang] The language of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsByTransferIdByDocumentReferenceIdGet: function (transferId, documentReferenceId, lang, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'transferId' is not null or undefined
            if (transferId === null || transferId === undefined) {
                throw new base_1.RequiredError('transferId', 'Required parameter transferId was null or undefined when calling apiV1DocumentsByTransferIdByDocumentReferenceIdGet.');
            }
            // verify required parameter 'documentReferenceId' is not null or undefined
            if (documentReferenceId === null || documentReferenceId === undefined) {
                throw new base_1.RequiredError('documentReferenceId', 'Required parameter documentReferenceId was null or undefined when calling apiV1DocumentsByTransferIdByDocumentReferenceIdGet.');
            }
            var localVarPath = "/api/v1/documents/{transferId}/{documentReferenceId}"
                .replace("{" + "transferId" + "}", encodeURIComponent(String(transferId)))
                .replace("{" + "documentReferenceId" + "}", encodeURIComponent(String(documentReferenceId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the details of a document by transfer id
         * @param {string} transferId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsByTransferIdDetailsGet: function (transferId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'transferId' is not null or undefined
            if (transferId === null || transferId === undefined) {
                throw new base_1.RequiredError('transferId', 'Required parameter transferId was null or undefined when calling apiV1DocumentsByTransferIdDetailsGet.');
            }
            var localVarPath = "/api/v1/documents/{transferId}/details"
                .replace("{" + "transferId" + "}", encodeURIComponent(String(transferId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} transferId Document transfer guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsByTransferIdDocumentReferencesGet: function (transferId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'transferId' is not null or undefined
            if (transferId === null || transferId === undefined) {
                throw new base_1.RequiredError('transferId', 'Required parameter transferId was null or undefined when calling apiV1DocumentsByTransferIdDocumentReferencesGet.');
            }
            var localVarPath = "/api/v1/documents/{transferId}/document-references"
                .replace("{" + "transferId" + "}", encodeURIComponent(String(transferId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a document by transfer id
         * @param {string} transferId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsByTransferIdGet: function (transferId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'transferId' is not null or undefined
            if (transferId === null || transferId === undefined) {
                throw new base_1.RequiredError('transferId', 'Required parameter transferId was null or undefined when calling apiV1DocumentsByTransferIdGet.');
            }
            var localVarPath = "/api/v1/documents/{transferId}"
                .replace("{" + "transferId" + "}", encodeURIComponent(String(transferId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} transferId Document transfer guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsByTransferIdLinkedDocumentsGet: function (transferId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'transferId' is not null or undefined
            if (transferId === null || transferId === undefined) {
                throw new base_1.RequiredError('transferId', 'Required parameter transferId was null or undefined when calling apiV1DocumentsByTransferIdLinkedDocumentsGet.');
            }
            var localVarPath = "/api/v1/documents/{transferId}/linked-documents"
                .replace("{" + "transferId" + "}", encodeURIComponent(String(transferId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Look up for documents
         * @param {string} [vendorIsoId]
         * @param {string} [vendorName]
         * @param {string} [documentType]
         * @param {string} [documentNumber]
         * @param {Date} [issueDateFrom]
         * @param {Date} [issueDateTo]
         * @param {Date} [dueDateFrom]
         * @param {Date} [dueDateTo]
         * @param {string} [roleKeyName]
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsGet: function (vendorIsoId, vendorName, documentType, documentNumber, issueDateFrom, issueDateTo, dueDateFrom, dueDateTo, roleKeyName, textFilter, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/documents";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (vendorIsoId !== undefined) {
                localVarQueryParameter['VendorIsoId'] = vendorIsoId;
            }
            if (vendorName !== undefined) {
                localVarQueryParameter['VendorName'] = vendorName;
            }
            if (documentType !== undefined) {
                localVarQueryParameter['DocumentType'] = documentType;
            }
            if (documentNumber !== undefined) {
                localVarQueryParameter['DocumentNumber'] = documentNumber;
            }
            if (issueDateFrom !== undefined) {
                localVarQueryParameter['IssueDateFrom'] = (issueDateFrom instanceof Date) ?
                    issueDateFrom.toISOString() :
                    issueDateFrom;
            }
            if (issueDateTo !== undefined) {
                localVarQueryParameter['IssueDateTo'] = (issueDateTo instanceof Date) ?
                    issueDateTo.toISOString() :
                    issueDateTo;
            }
            if (dueDateFrom !== undefined) {
                localVarQueryParameter['DueDateFrom'] = (dueDateFrom instanceof Date) ?
                    dueDateFrom.toISOString() :
                    dueDateFrom;
            }
            if (dueDateTo !== undefined) {
                localVarQueryParameter['DueDateTo'] = (dueDateTo instanceof Date) ?
                    dueDateTo.toISOString() :
                    dueDateTo;
            }
            if (roleKeyName !== undefined) {
                localVarQueryParameter['RoleKeyName'] = roleKeyName;
            }
            if (textFilter !== undefined) {
                localVarQueryParameter['TextFilter'] = textFilter;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a thread
         * @param {CreateComplaintMessageThread} [messageThreadToCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsThreadPost: function (messageThreadToCreate, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/documents/thread";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof messageThreadToCreate !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(messageThreadToCreate !== undefined ? messageThreadToCreate : {}) : (messageThreadToCreate || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocumentApi - functional programming interface
 * @export
 */
exports.DocumentApiFp = function (configuration) {
    return {
        /**
         * Binaries will be streamed directly from payload if payload exists or from remote resource accessible via link.  <br />  Document reference have to belong to specified transfer id; there are checks for this returning error response if this is not the case.
         * @param {string} transferId Document transfer guid
         * @param {number} documentReferenceId Document reference id
         * @param {string} [lang] The language of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsByTransferIdByDocumentReferenceIdGet: function (transferId, documentReferenceId, lang, options) {
            var localVarAxiosArgs = exports.DocumentApiAxiosParamCreator(configuration).apiV1DocumentsByTransferIdByDocumentReferenceIdGet(transferId, documentReferenceId, lang, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get the details of a document by transfer id
         * @param {string} transferId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsByTransferIdDetailsGet: function (transferId, options) {
            var localVarAxiosArgs = exports.DocumentApiAxiosParamCreator(configuration).apiV1DocumentsByTransferIdDetailsGet(transferId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} transferId Document transfer guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsByTransferIdDocumentReferencesGet: function (transferId, options) {
            var localVarAxiosArgs = exports.DocumentApiAxiosParamCreator(configuration).apiV1DocumentsByTransferIdDocumentReferencesGet(transferId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get a document by transfer id
         * @param {string} transferId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsByTransferIdGet: function (transferId, options) {
            var localVarAxiosArgs = exports.DocumentApiAxiosParamCreator(configuration).apiV1DocumentsByTransferIdGet(transferId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} transferId Document transfer guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsByTransferIdLinkedDocumentsGet: function (transferId, options) {
            var localVarAxiosArgs = exports.DocumentApiAxiosParamCreator(configuration).apiV1DocumentsByTransferIdLinkedDocumentsGet(transferId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Look up for documents
         * @param {string} [vendorIsoId]
         * @param {string} [vendorName]
         * @param {string} [documentType]
         * @param {string} [documentNumber]
         * @param {Date} [issueDateFrom]
         * @param {Date} [issueDateTo]
         * @param {Date} [dueDateFrom]
         * @param {Date} [dueDateTo]
         * @param {string} [roleKeyName]
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsGet: function (vendorIsoId, vendorName, documentType, documentNumber, issueDateFrom, issueDateTo, dueDateFrom, dueDateTo, roleKeyName, textFilter, offset, limit, options) {
            var localVarAxiosArgs = exports.DocumentApiAxiosParamCreator(configuration).apiV1DocumentsGet(vendorIsoId, vendorName, documentType, documentNumber, issueDateFrom, issueDateTo, dueDateFrom, dueDateTo, roleKeyName, textFilter, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Create a thread
         * @param {CreateComplaintMessageThread} [messageThreadToCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsThreadPost: function (messageThreadToCreate, options) {
            var localVarAxiosArgs = exports.DocumentApiAxiosParamCreator(configuration).apiV1DocumentsThreadPost(messageThreadToCreate, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * DocumentApi - factory interface
 * @export
 */
exports.DocumentApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * Binaries will be streamed directly from payload if payload exists or from remote resource accessible via link.  <br />  Document reference have to belong to specified transfer id; there are checks for this returning error response if this is not the case.
         * @param {string} transferId Document transfer guid
         * @param {number} documentReferenceId Document reference id
         * @param {string} [lang] The language of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsByTransferIdByDocumentReferenceIdGet: function (transferId, documentReferenceId, lang, options) {
            return exports.DocumentApiFp(configuration).apiV1DocumentsByTransferIdByDocumentReferenceIdGet(transferId, documentReferenceId, lang, options)(axios, basePath);
        },
        /**
         *
         * @summary Get the details of a document by transfer id
         * @param {string} transferId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsByTransferIdDetailsGet: function (transferId, options) {
            return exports.DocumentApiFp(configuration).apiV1DocumentsByTransferIdDetailsGet(transferId, options)(axios, basePath);
        },
        /**
         *
         * @param {string} transferId Document transfer guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsByTransferIdDocumentReferencesGet: function (transferId, options) {
            return exports.DocumentApiFp(configuration).apiV1DocumentsByTransferIdDocumentReferencesGet(transferId, options)(axios, basePath);
        },
        /**
         *
         * @summary Get a document by transfer id
         * @param {string} transferId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsByTransferIdGet: function (transferId, options) {
            return exports.DocumentApiFp(configuration).apiV1DocumentsByTransferIdGet(transferId, options)(axios, basePath);
        },
        /**
         *
         * @param {string} transferId Document transfer guid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsByTransferIdLinkedDocumentsGet: function (transferId, options) {
            return exports.DocumentApiFp(configuration).apiV1DocumentsByTransferIdLinkedDocumentsGet(transferId, options)(axios, basePath);
        },
        /**
         *
         * @summary Look up for documents
         * @param {string} [vendorIsoId]
         * @param {string} [vendorName]
         * @param {string} [documentType]
         * @param {string} [documentNumber]
         * @param {Date} [issueDateFrom]
         * @param {Date} [issueDateTo]
         * @param {Date} [dueDateFrom]
         * @param {Date} [dueDateTo]
         * @param {string} [roleKeyName]
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsGet: function (vendorIsoId, vendorName, documentType, documentNumber, issueDateFrom, issueDateTo, dueDateFrom, dueDateTo, roleKeyName, textFilter, offset, limit, options) {
            return exports.DocumentApiFp(configuration).apiV1DocumentsGet(vendorIsoId, vendorName, documentType, documentNumber, issueDateFrom, issueDateTo, dueDateFrom, dueDateTo, roleKeyName, textFilter, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @summary Create a thread
         * @param {CreateComplaintMessageThread} [messageThreadToCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DocumentsThreadPost: function (messageThreadToCreate, options) {
            return exports.DocumentApiFp(configuration).apiV1DocumentsThreadPost(messageThreadToCreate, options)(axios, basePath);
        },
    };
};
/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
var DocumentApi = /** @class */ (function (_super) {
    __extends(DocumentApi, _super);
    function DocumentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Binaries will be streamed directly from payload if payload exists or from remote resource accessible via link.  <br />  Document reference have to belong to specified transfer id; there are checks for this returning error response if this is not the case.
     * @param {string} transferId Document transfer guid
     * @param {number} documentReferenceId Document reference id
     * @param {string} [lang] The language of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    DocumentApi.prototype.apiV1DocumentsByTransferIdByDocumentReferenceIdGet = function (transferId, documentReferenceId, lang, options) {
        return exports.DocumentApiFp(this.configuration).apiV1DocumentsByTransferIdByDocumentReferenceIdGet(transferId, documentReferenceId, lang, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get the details of a document by transfer id
     * @param {string} transferId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    DocumentApi.prototype.apiV1DocumentsByTransferIdDetailsGet = function (transferId, options) {
        return exports.DocumentApiFp(this.configuration).apiV1DocumentsByTransferIdDetailsGet(transferId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} transferId Document transfer guid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    DocumentApi.prototype.apiV1DocumentsByTransferIdDocumentReferencesGet = function (transferId, options) {
        return exports.DocumentApiFp(this.configuration).apiV1DocumentsByTransferIdDocumentReferencesGet(transferId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get a document by transfer id
     * @param {string} transferId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    DocumentApi.prototype.apiV1DocumentsByTransferIdGet = function (transferId, options) {
        return exports.DocumentApiFp(this.configuration).apiV1DocumentsByTransferIdGet(transferId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} transferId Document transfer guid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    DocumentApi.prototype.apiV1DocumentsByTransferIdLinkedDocumentsGet = function (transferId, options) {
        return exports.DocumentApiFp(this.configuration).apiV1DocumentsByTransferIdLinkedDocumentsGet(transferId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Look up for documents
     * @param {string} [vendorIsoId]
     * @param {string} [vendorName]
     * @param {string} [documentType]
     * @param {string} [documentNumber]
     * @param {Date} [issueDateFrom]
     * @param {Date} [issueDateTo]
     * @param {Date} [dueDateFrom]
     * @param {Date} [dueDateTo]
     * @param {string} [roleKeyName]
     * @param {string} [textFilter]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    DocumentApi.prototype.apiV1DocumentsGet = function (vendorIsoId, vendorName, documentType, documentNumber, issueDateFrom, issueDateTo, dueDateFrom, dueDateTo, roleKeyName, textFilter, offset, limit, options) {
        return exports.DocumentApiFp(this.configuration).apiV1DocumentsGet(vendorIsoId, vendorName, documentType, documentNumber, issueDateFrom, issueDateTo, dueDateFrom, dueDateTo, roleKeyName, textFilter, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Create a thread
     * @param {CreateComplaintMessageThread} [messageThreadToCreate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    DocumentApi.prototype.apiV1DocumentsThreadPost = function (messageThreadToCreate, options) {
        return exports.DocumentApiFp(this.configuration).apiV1DocumentsThreadPost(messageThreadToCreate, options)(this.axios, this.basePath);
    };
    return DocumentApi;
}(base_1.BaseAPI));
exports.DocumentApi = DocumentApi;
/**
 * IdentityApi - axios parameter creator
 * @export
 */
exports.IdentityApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IdentityGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/identity";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * IdentityApi - functional programming interface
 * @export
 */
exports.IdentityApiFp = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IdentityGet: function (options) {
            var localVarAxiosArgs = exports.IdentityApiAxiosParamCreator(configuration).apiV1IdentityGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * IdentityApi - factory interface
 * @export
 */
exports.IdentityApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IdentityGet: function (options) {
            return exports.IdentityApiFp(configuration).apiV1IdentityGet(options)(axios, basePath);
        },
    };
};
/**
 * IdentityApi - object-oriented interface
 * @export
 * @class IdentityApi
 * @extends {BaseAPI}
 */
var IdentityApi = /** @class */ (function (_super) {
    __extends(IdentityApi, _super);
    function IdentityApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityApi
     */
    IdentityApi.prototype.apiV1IdentityGet = function (options) {
        return exports.IdentityApiFp(this.configuration).apiV1IdentityGet(options)(this.axios, this.basePath);
    };
    return IdentityApi;
}(base_1.BaseAPI));
exports.IdentityApi = IdentityApi;
/**
 * IntegrationApi - axios parameter creator
 * @export
 */
exports.IntegrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} actorApiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationBaseValidatetokenByActorApiKeyGet: function (actorApiKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'actorApiKey' is not null or undefined
            if (actorApiKey === null || actorApiKey === undefined) {
                throw new base_1.RequiredError('actorApiKey', 'Required parameter actorApiKey was null or undefined when calling apiV1IntegrationBaseValidatetokenByActorApiKeyGet.');
            }
            var localVarPath = "/api/v1/integration/base/validatetoken/{actorApiKey}"
                .replace("{" + "actorApiKey" + "}", encodeURIComponent(String(actorApiKey)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {string} [action]
         * @param {string} [status]
         * @param {Date} [from]
         * @param {Date} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierGet: function (creatorLegalIsoIdentifier, action, status, from, to, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'creatorLegalIsoIdentifier' is not null or undefined
            if (creatorLegalIsoIdentifier === null || creatorLegalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('creatorLegalIsoIdentifier', 'Required parameter creatorLegalIsoIdentifier was null or undefined when calling apiV1IntegrationRecipesByCreatorLegalIsoIdentifierGet.');
            }
            var localVarPath = "/api/v1/integration/recipes/{creatorLegalIsoIdentifier}"
                .replace("{" + "creatorLegalIsoIdentifier" + "}", encodeURIComponent(String(creatorLegalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {Array<RecipeRes>} [recipes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierPost: function (creatorLegalIsoIdentifier, recipes, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'creatorLegalIsoIdentifier' is not null or undefined
            if (creatorLegalIsoIdentifier === null || creatorLegalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('creatorLegalIsoIdentifier', 'Required parameter creatorLegalIsoIdentifier was null or undefined when calling apiV1IntegrationRecipesByCreatorLegalIsoIdentifierPost.');
            }
            var localVarPath = "/api/v1/integration/recipes/{creatorLegalIsoIdentifier}"
                .replace("{" + "creatorLegalIsoIdentifier" + "}", encodeURIComponent(String(creatorLegalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof recipes !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(recipes !== undefined ? recipes : {}) : (recipes || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyDelete: function (creatorLegalIsoIdentifier, key, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'creatorLegalIsoIdentifier' is not null or undefined
            if (creatorLegalIsoIdentifier === null || creatorLegalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('creatorLegalIsoIdentifier', 'Required parameter creatorLegalIsoIdentifier was null or undefined when calling apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyDelete.');
            }
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new base_1.RequiredError('key', 'Required parameter key was null or undefined when calling apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyDelete.');
            }
            var localVarPath = "/api/v1/integration/recipes/{creatorLegalIsoIdentifier}/recipe-batches/{key}"
                .replace("{" + "creatorLegalIsoIdentifier" + "}", encodeURIComponent(String(creatorLegalIsoIdentifier)))
                .replace("{" + "key" + "}", encodeURIComponent(String(key)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyGet: function (creatorLegalIsoIdentifier, key, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'creatorLegalIsoIdentifier' is not null or undefined
            if (creatorLegalIsoIdentifier === null || creatorLegalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('creatorLegalIsoIdentifier', 'Required parameter creatorLegalIsoIdentifier was null or undefined when calling apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyGet.');
            }
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new base_1.RequiredError('key', 'Required parameter key was null or undefined when calling apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyGet.');
            }
            var localVarPath = "/api/v1/integration/recipes/{creatorLegalIsoIdentifier}/recipe-batches/{key}"
                .replace("{" + "creatorLegalIsoIdentifier" + "}", encodeURIComponent(String(creatorLegalIsoIdentifier)))
                .replace("{" + "key" + "}", encodeURIComponent(String(key)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost: function (creatorLegalIsoIdentifier, key, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'creatorLegalIsoIdentifier' is not null or undefined
            if (creatorLegalIsoIdentifier === null || creatorLegalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('creatorLegalIsoIdentifier', 'Required parameter creatorLegalIsoIdentifier was null or undefined when calling apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost.');
            }
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new base_1.RequiredError('key', 'Required parameter key was null or undefined when calling apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost.');
            }
            var localVarPath = "/api/v1/integration/recipes/{creatorLegalIsoIdentifier}/recipe-batches/{key}/mark-imported"
                .replace("{" + "creatorLegalIsoIdentifier" + "}", encodeURIComponent(String(creatorLegalIsoIdentifier)))
                .replace("{" + "key" + "}", encodeURIComponent(String(key)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRelatedCompaniesGet: function (creatorLegalIsoIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'creatorLegalIsoIdentifier' is not null or undefined
            if (creatorLegalIsoIdentifier === null || creatorLegalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('creatorLegalIsoIdentifier', 'Required parameter creatorLegalIsoIdentifier was null or undefined when calling apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRelatedCompaniesGet.');
            }
            var localVarPath = "/api/v1/integration/recipes/{creatorLegalIsoIdentifier}/related-companies"
                .replace("{" + "creatorLegalIsoIdentifier" + "}", encodeURIComponent(String(creatorLegalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [action]
         * @param {string} [status]
         * @param {Date} [from]
         * @param {Date} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesGet: function (action, status, from, to, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/integration/recipes";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * IntegrationApi - functional programming interface
 * @export
 */
exports.IntegrationApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} actorApiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationBaseValidatetokenByActorApiKeyGet: function (actorApiKey, options) {
            var localVarAxiosArgs = exports.IntegrationApiAxiosParamCreator(configuration).apiV1IntegrationBaseValidatetokenByActorApiKeyGet(actorApiKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {string} [action]
         * @param {string} [status]
         * @param {Date} [from]
         * @param {Date} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierGet: function (creatorLegalIsoIdentifier, action, status, from, to, options) {
            var localVarAxiosArgs = exports.IntegrationApiAxiosParamCreator(configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierGet(creatorLegalIsoIdentifier, action, status, from, to, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {Array<RecipeRes>} [recipes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierPost: function (creatorLegalIsoIdentifier, recipes, options) {
            var localVarAxiosArgs = exports.IntegrationApiAxiosParamCreator(configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierPost(creatorLegalIsoIdentifier, recipes, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyDelete: function (creatorLegalIsoIdentifier, key, options) {
            var localVarAxiosArgs = exports.IntegrationApiAxiosParamCreator(configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyDelete(creatorLegalIsoIdentifier, key, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyGet: function (creatorLegalIsoIdentifier, key, options) {
            var localVarAxiosArgs = exports.IntegrationApiAxiosParamCreator(configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyGet(creatorLegalIsoIdentifier, key, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost: function (creatorLegalIsoIdentifier, key, options) {
            var localVarAxiosArgs = exports.IntegrationApiAxiosParamCreator(configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost(creatorLegalIsoIdentifier, key, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRelatedCompaniesGet: function (creatorLegalIsoIdentifier, options) {
            var localVarAxiosArgs = exports.IntegrationApiAxiosParamCreator(configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRelatedCompaniesGet(creatorLegalIsoIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} [action]
         * @param {string} [status]
         * @param {Date} [from]
         * @param {Date} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesGet: function (action, status, from, to, options) {
            var localVarAxiosArgs = exports.IntegrationApiAxiosParamCreator(configuration).apiV1IntegrationRecipesGet(action, status, from, to, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * IntegrationApi - factory interface
 * @export
 */
exports.IntegrationApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {string} actorApiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationBaseValidatetokenByActorApiKeyGet: function (actorApiKey, options) {
            return exports.IntegrationApiFp(configuration).apiV1IntegrationBaseValidatetokenByActorApiKeyGet(actorApiKey, options)(axios, basePath);
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {string} [action]
         * @param {string} [status]
         * @param {Date} [from]
         * @param {Date} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierGet: function (creatorLegalIsoIdentifier, action, status, from, to, options) {
            return exports.IntegrationApiFp(configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierGet(creatorLegalIsoIdentifier, action, status, from, to, options)(axios, basePath);
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {Array<RecipeRes>} [recipes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierPost: function (creatorLegalIsoIdentifier, recipes, options) {
            return exports.IntegrationApiFp(configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierPost(creatorLegalIsoIdentifier, recipes, options)(axios, basePath);
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyDelete: function (creatorLegalIsoIdentifier, key, options) {
            return exports.IntegrationApiFp(configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyDelete(creatorLegalIsoIdentifier, key, options)(axios, basePath);
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyGet: function (creatorLegalIsoIdentifier, key, options) {
            return exports.IntegrationApiFp(configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyGet(creatorLegalIsoIdentifier, key, options)(axios, basePath);
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost: function (creatorLegalIsoIdentifier, key, options) {
            return exports.IntegrationApiFp(configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost(creatorLegalIsoIdentifier, key, options)(axios, basePath);
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRelatedCompaniesGet: function (creatorLegalIsoIdentifier, options) {
            return exports.IntegrationApiFp(configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRelatedCompaniesGet(creatorLegalIsoIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @param {string} [action]
         * @param {string} [status]
         * @param {Date} [from]
         * @param {Date} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationRecipesGet: function (action, status, from, to, options) {
            return exports.IntegrationApiFp(configuration).apiV1IntegrationRecipesGet(action, status, from, to, options)(axios, basePath);
        },
    };
};
/**
 * IntegrationApi - object-oriented interface
 * @export
 * @class IntegrationApi
 * @extends {BaseAPI}
 */
var IntegrationApi = /** @class */ (function (_super) {
    __extends(IntegrationApi, _super);
    function IntegrationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} actorApiKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    IntegrationApi.prototype.apiV1IntegrationBaseValidatetokenByActorApiKeyGet = function (actorApiKey, options) {
        return exports.IntegrationApiFp(this.configuration).apiV1IntegrationBaseValidatetokenByActorApiKeyGet(actorApiKey, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} creatorLegalIsoIdentifier
     * @param {string} [action]
     * @param {string} [status]
     * @param {Date} [from]
     * @param {Date} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    IntegrationApi.prototype.apiV1IntegrationRecipesByCreatorLegalIsoIdentifierGet = function (creatorLegalIsoIdentifier, action, status, from, to, options) {
        return exports.IntegrationApiFp(this.configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierGet(creatorLegalIsoIdentifier, action, status, from, to, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} creatorLegalIsoIdentifier
     * @param {Array<RecipeRes>} [recipes]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    IntegrationApi.prototype.apiV1IntegrationRecipesByCreatorLegalIsoIdentifierPost = function (creatorLegalIsoIdentifier, recipes, options) {
        return exports.IntegrationApiFp(this.configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierPost(creatorLegalIsoIdentifier, recipes, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} creatorLegalIsoIdentifier
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    IntegrationApi.prototype.apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyDelete = function (creatorLegalIsoIdentifier, key, options) {
        return exports.IntegrationApiFp(this.configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyDelete(creatorLegalIsoIdentifier, key, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} creatorLegalIsoIdentifier
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    IntegrationApi.prototype.apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyGet = function (creatorLegalIsoIdentifier, key, options) {
        return exports.IntegrationApiFp(this.configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyGet(creatorLegalIsoIdentifier, key, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} creatorLegalIsoIdentifier
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    IntegrationApi.prototype.apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost = function (creatorLegalIsoIdentifier, key, options) {
        return exports.IntegrationApiFp(this.configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost(creatorLegalIsoIdentifier, key, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} creatorLegalIsoIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    IntegrationApi.prototype.apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRelatedCompaniesGet = function (creatorLegalIsoIdentifier, options) {
        return exports.IntegrationApiFp(this.configuration).apiV1IntegrationRecipesByCreatorLegalIsoIdentifierRelatedCompaniesGet(creatorLegalIsoIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} [action]
     * @param {string} [status]
     * @param {Date} [from]
     * @param {Date} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    IntegrationApi.prototype.apiV1IntegrationRecipesGet = function (action, status, from, to, options) {
        return exports.IntegrationApiFp(this.configuration).apiV1IntegrationRecipesGet(action, status, from, to, options)(this.axios, this.basePath);
    };
    return IntegrationApi;
}(base_1.BaseAPI));
exports.IntegrationApi = IntegrationApi;
/**
 * MessageThreadsApi - axios parameter creator
 * @export
 */
exports.MessageThreadsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary This method marks a thread as closed and optionally gives rating.
         * @param {string} threadId
         * @param {MessageThreadRate} [rate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdCloseandratePut: function (threadId, rate, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'threadId' is not null or undefined
            if (threadId === null || threadId === undefined) {
                throw new base_1.RequiredError('threadId', 'Required parameter threadId was null or undefined when calling apiV1ThreadsByThreadIdCloseandratePut.');
            }
            var localVarPath = "/api/v1/threads/{threadId}/closeandrate"
                .replace("{" + "threadId" + "}", encodeURIComponent(String(threadId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof rate !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(rate !== undefined ? rate : {}) : (rate || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This method requests closing.
         * @param {string} threadId
         * @param {MessageThreadBase} [messageThread]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdCloserequestPost: function (threadId, messageThread, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'threadId' is not null or undefined
            if (threadId === null || threadId === undefined) {
                throw new base_1.RequiredError('threadId', 'Required parameter threadId was null or undefined when calling apiV1ThreadsByThreadIdCloserequestPost.');
            }
            var localVarPath = "/api/v1/threads/{threadId}/closerequest"
                .replace("{" + "threadId" + "}", encodeURIComponent(String(threadId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof messageThread !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(messageThread !== undefined ? messageThread : {}) : (messageThread || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returning a thread view by thread id.
         * @param {string} threadId
         * @param {string} [markAsRead]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdGet: function (threadId, markAsRead, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'threadId' is not null or undefined
            if (threadId === null || threadId === undefined) {
                throw new base_1.RequiredError('threadId', 'Required parameter threadId was null or undefined when calling apiV1ThreadsByThreadIdGet.');
            }
            var localVarPath = "/api/v1/threads/{threadId}"
                .replace("{" + "threadId" + "}", encodeURIComponent(String(threadId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (markAsRead !== undefined) {
                localVarQueryParameter['markAsRead'] = markAsRead;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} threadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdLinkedDocumentsGet: function (threadId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'threadId' is not null or undefined
            if (threadId === null || threadId === undefined) {
                throw new base_1.RequiredError('threadId', 'Required parameter threadId was null or undefined when calling apiV1ThreadsByThreadIdLinkedDocumentsGet.');
            }
            var localVarPath = "/api/v1/threads/{threadId}/linked-documents"
                .replace("{" + "threadId" + "}", encodeURIComponent(String(threadId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returning a thread view by thread id.
         * @param {string} threadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdParticipantsGet: function (threadId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'threadId' is not null or undefined
            if (threadId === null || threadId === undefined) {
                throw new base_1.RequiredError('threadId', 'Required parameter threadId was null or undefined when calling apiV1ThreadsByThreadIdParticipantsGet.');
            }
            var localVarPath = "/api/v1/threads/{threadId}/participants"
                .replace("{" + "threadId" + "}", encodeURIComponent(String(threadId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This method gives rating.
         * @param {string} threadId
         * @param {MessageThreadRate} [rate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdRatePost: function (threadId, rate, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'threadId' is not null or undefined
            if (threadId === null || threadId === undefined) {
                throw new base_1.RequiredError('threadId', 'Required parameter threadId was null or undefined when calling apiV1ThreadsByThreadIdRatePost.');
            }
            var localVarPath = "/api/v1/threads/{threadId}/rate"
                .replace("{" + "threadId" + "}", encodeURIComponent(String(threadId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof rate !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(rate !== undefined ? rate : {}) : (rate || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This method requests rating.
         * @param {string} threadId
         * @param {MessageThreadBase} [messageThread]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdRaterequestPost: function (threadId, messageThread, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'threadId' is not null or undefined
            if (threadId === null || threadId === undefined) {
                throw new base_1.RequiredError('threadId', 'Required parameter threadId was null or undefined when calling apiV1ThreadsByThreadIdRaterequestPost.');
            }
            var localVarPath = "/api/v1/threads/{threadId}/raterequest"
                .replace("{" + "threadId" + "}", encodeURIComponent(String(threadId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof messageThread !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(messageThread !== undefined ? messageThread : {}) : (messageThread || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get replies by thread id ordered by created dateTime.
         * @param {string} threadId
         * @param {number} [index]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdRepliesGet: function (threadId, index, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'threadId' is not null or undefined
            if (threadId === null || threadId === undefined) {
                throw new base_1.RequiredError('threadId', 'Required parameter threadId was null or undefined when calling apiV1ThreadsByThreadIdRepliesGet.');
            }
            var localVarPath = "/api/v1/threads/{threadId}/replies"
                .replace("{" + "threadId" + "}", encodeURIComponent(String(threadId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (index !== undefined) {
                localVarQueryParameter['index'] = index;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary This method performs message reply post.
         * @param {string} threadId
         * @param {CreateMessageReply} [messageReplyToCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdRepliesPost: function (threadId, messageReplyToCreate, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'threadId' is not null or undefined
            if (threadId === null || threadId === undefined) {
                throw new base_1.RequiredError('threadId', 'Required parameter threadId was null or undefined when calling apiV1ThreadsByThreadIdRepliesPost.');
            }
            var localVarPath = "/api/v1/threads/{threadId}/replies"
                .replace("{" + "threadId" + "}", encodeURIComponent(String(threadId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof messageReplyToCreate !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(messageReplyToCreate !== undefined ? messageReplyToCreate : {}) : (messageReplyToCreate || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update the ResponderProgressStatus for the thread with the provided threadId
         * @param {string} threadId
         * @param {string} statusKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdStatusByStatusKeyPost: function (threadId, statusKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'threadId' is not null or undefined
            if (threadId === null || threadId === undefined) {
                throw new base_1.RequiredError('threadId', 'Required parameter threadId was null or undefined when calling apiV1ThreadsByThreadIdStatusByStatusKeyPost.');
            }
            // verify required parameter 'statusKey' is not null or undefined
            if (statusKey === null || statusKey === undefined) {
                throw new base_1.RequiredError('statusKey', 'Required parameter statusKey was null or undefined when calling apiV1ThreadsByThreadIdStatusByStatusKeyPost.');
            }
            var localVarPath = "/api/v1/threads/{threadId}/status/{statusKey}"
                .replace("{" + "threadId" + "}", encodeURIComponent(String(threadId)))
                .replace("{" + "statusKey" + "}", encodeURIComponent(String(statusKey)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returning list of threads.
         * @param {'All' | 'Active' | 'NotResponded' | 'Closed'} [messageThreadStatus]
         * @param {'IncomingRequest' | 'OutgoingQuery'} [messageThreadDirection]
         * @param {string} [documentNumber]
         * @param {'Invoice' | 'CreditNote' | 'Order' | 'RemittanceAdvice' | 'Unspecified'} [documentType]
         * @param {string} [responder]
         * @param {string} [initiator]
         * @param {Date} [createdFromTime]
         * @param {Date} [createdToTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsFilteredGet: function (messageThreadStatus, messageThreadDirection, documentNumber, documentType, responder, initiator, createdFromTime, createdToTime, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/threads/filtered";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (messageThreadStatus !== undefined) {
                localVarQueryParameter['MessageThreadStatus'] = messageThreadStatus;
            }
            if (messageThreadDirection !== undefined) {
                localVarQueryParameter['MessageThreadDirection'] = messageThreadDirection;
            }
            if (documentNumber !== undefined) {
                localVarQueryParameter['DocumentNumber'] = documentNumber;
            }
            if (documentType !== undefined) {
                localVarQueryParameter['DocumentType'] = documentType;
            }
            if (responder !== undefined) {
                localVarQueryParameter['Responder'] = responder;
            }
            if (initiator !== undefined) {
                localVarQueryParameter['Initiator'] = initiator;
            }
            if (createdFromTime !== undefined) {
                localVarQueryParameter['CreatedFromTime'] = (createdFromTime instanceof Date) ?
                    createdFromTime.toISOString() :
                    createdFromTime;
            }
            if (createdToTime !== undefined) {
                localVarQueryParameter['CreatedToTime'] = (createdToTime instanceof Date) ?
                    createdToTime.toISOString() :
                    createdToTime;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returning list of threads.
         * @param {'All' | 'IncomingRequest' | 'OutgoingQuery'} [messageType]
         * @param {'All' | 'Bill' | 'Order'} [documentType]
         * @param {'User' | 'Department' | 'Company'} [messageScope]
         * @param {'All' | 'Active' | 'NotResponded' | 'Closed'} [messageThreadStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsGet: function (messageType, documentType, messageScope, messageThreadStatus, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/threads";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (messageType !== undefined) {
                localVarQueryParameter['MessageType'] = messageType;
            }
            if (documentType !== undefined) {
                localVarQueryParameter['DocumentType'] = documentType;
            }
            if (messageScope !== undefined) {
                localVarQueryParameter['MessageScope'] = messageScope;
            }
            if (messageThreadStatus !== undefined) {
                localVarQueryParameter['MessageThreadStatus'] = messageThreadStatus;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Use this in order to post message thread.
         * @param {CreateComplaintMessageThread} [messageThreadToCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsPost: function (messageThreadToCreate, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/threads";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof messageThreadToCreate !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(messageThreadToCreate !== undefined ? messageThreadToCreate : {}) : (messageThreadToCreate || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * MessageThreadsApi - functional programming interface
 * @export
 */
exports.MessageThreadsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary This method marks a thread as closed and optionally gives rating.
         * @param {string} threadId
         * @param {MessageThreadRate} [rate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdCloseandratePut: function (threadId, rate, options) {
            var localVarAxiosArgs = exports.MessageThreadsApiAxiosParamCreator(configuration).apiV1ThreadsByThreadIdCloseandratePut(threadId, rate, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary This method requests closing.
         * @param {string} threadId
         * @param {MessageThreadBase} [messageThread]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdCloserequestPost: function (threadId, messageThread, options) {
            var localVarAxiosArgs = exports.MessageThreadsApiAxiosParamCreator(configuration).apiV1ThreadsByThreadIdCloserequestPost(threadId, messageThread, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returning a thread view by thread id.
         * @param {string} threadId
         * @param {string} [markAsRead]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdGet: function (threadId, markAsRead, options) {
            var localVarAxiosArgs = exports.MessageThreadsApiAxiosParamCreator(configuration).apiV1ThreadsByThreadIdGet(threadId, markAsRead, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} threadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdLinkedDocumentsGet: function (threadId, options) {
            var localVarAxiosArgs = exports.MessageThreadsApiAxiosParamCreator(configuration).apiV1ThreadsByThreadIdLinkedDocumentsGet(threadId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returning a thread view by thread id.
         * @param {string} threadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdParticipantsGet: function (threadId, options) {
            var localVarAxiosArgs = exports.MessageThreadsApiAxiosParamCreator(configuration).apiV1ThreadsByThreadIdParticipantsGet(threadId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary This method gives rating.
         * @param {string} threadId
         * @param {MessageThreadRate} [rate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdRatePost: function (threadId, rate, options) {
            var localVarAxiosArgs = exports.MessageThreadsApiAxiosParamCreator(configuration).apiV1ThreadsByThreadIdRatePost(threadId, rate, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary This method requests rating.
         * @param {string} threadId
         * @param {MessageThreadBase} [messageThread]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdRaterequestPost: function (threadId, messageThread, options) {
            var localVarAxiosArgs = exports.MessageThreadsApiAxiosParamCreator(configuration).apiV1ThreadsByThreadIdRaterequestPost(threadId, messageThread, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get replies by thread id ordered by created dateTime.
         * @param {string} threadId
         * @param {number} [index]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdRepliesGet: function (threadId, index, options) {
            var localVarAxiosArgs = exports.MessageThreadsApiAxiosParamCreator(configuration).apiV1ThreadsByThreadIdRepliesGet(threadId, index, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary This method performs message reply post.
         * @param {string} threadId
         * @param {CreateMessageReply} [messageReplyToCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdRepliesPost: function (threadId, messageReplyToCreate, options) {
            var localVarAxiosArgs = exports.MessageThreadsApiAxiosParamCreator(configuration).apiV1ThreadsByThreadIdRepliesPost(threadId, messageReplyToCreate, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update the ResponderProgressStatus for the thread with the provided threadId
         * @param {string} threadId
         * @param {string} statusKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdStatusByStatusKeyPost: function (threadId, statusKey, options) {
            var localVarAxiosArgs = exports.MessageThreadsApiAxiosParamCreator(configuration).apiV1ThreadsByThreadIdStatusByStatusKeyPost(threadId, statusKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returning list of threads.
         * @param {'All' | 'Active' | 'NotResponded' | 'Closed'} [messageThreadStatus]
         * @param {'IncomingRequest' | 'OutgoingQuery'} [messageThreadDirection]
         * @param {string} [documentNumber]
         * @param {'Invoice' | 'CreditNote' | 'Order' | 'RemittanceAdvice' | 'Unspecified'} [documentType]
         * @param {string} [responder]
         * @param {string} [initiator]
         * @param {Date} [createdFromTime]
         * @param {Date} [createdToTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsFilteredGet: function (messageThreadStatus, messageThreadDirection, documentNumber, documentType, responder, initiator, createdFromTime, createdToTime, options) {
            var localVarAxiosArgs = exports.MessageThreadsApiAxiosParamCreator(configuration).apiV1ThreadsFilteredGet(messageThreadStatus, messageThreadDirection, documentNumber, documentType, responder, initiator, createdFromTime, createdToTime, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returning list of threads.
         * @param {'All' | 'IncomingRequest' | 'OutgoingQuery'} [messageType]
         * @param {'All' | 'Bill' | 'Order'} [documentType]
         * @param {'User' | 'Department' | 'Company'} [messageScope]
         * @param {'All' | 'Active' | 'NotResponded' | 'Closed'} [messageThreadStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsGet: function (messageType, documentType, messageScope, messageThreadStatus, options) {
            var localVarAxiosArgs = exports.MessageThreadsApiAxiosParamCreator(configuration).apiV1ThreadsGet(messageType, documentType, messageScope, messageThreadStatus, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Use this in order to post message thread.
         * @param {CreateComplaintMessageThread} [messageThreadToCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsPost: function (messageThreadToCreate, options) {
            var localVarAxiosArgs = exports.MessageThreadsApiAxiosParamCreator(configuration).apiV1ThreadsPost(messageThreadToCreate, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * MessageThreadsApi - factory interface
 * @export
 */
exports.MessageThreadsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary This method marks a thread as closed and optionally gives rating.
         * @param {string} threadId
         * @param {MessageThreadRate} [rate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdCloseandratePut: function (threadId, rate, options) {
            return exports.MessageThreadsApiFp(configuration).apiV1ThreadsByThreadIdCloseandratePut(threadId, rate, options)(axios, basePath);
        },
        /**
         *
         * @summary This method requests closing.
         * @param {string} threadId
         * @param {MessageThreadBase} [messageThread]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdCloserequestPost: function (threadId, messageThread, options) {
            return exports.MessageThreadsApiFp(configuration).apiV1ThreadsByThreadIdCloserequestPost(threadId, messageThread, options)(axios, basePath);
        },
        /**
         *
         * @summary Returning a thread view by thread id.
         * @param {string} threadId
         * @param {string} [markAsRead]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdGet: function (threadId, markAsRead, options) {
            return exports.MessageThreadsApiFp(configuration).apiV1ThreadsByThreadIdGet(threadId, markAsRead, options)(axios, basePath);
        },
        /**
         *
         * @param {string} threadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdLinkedDocumentsGet: function (threadId, options) {
            return exports.MessageThreadsApiFp(configuration).apiV1ThreadsByThreadIdLinkedDocumentsGet(threadId, options)(axios, basePath);
        },
        /**
         *
         * @summary Returning a thread view by thread id.
         * @param {string} threadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdParticipantsGet: function (threadId, options) {
            return exports.MessageThreadsApiFp(configuration).apiV1ThreadsByThreadIdParticipantsGet(threadId, options)(axios, basePath);
        },
        /**
         *
         * @summary This method gives rating.
         * @param {string} threadId
         * @param {MessageThreadRate} [rate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdRatePost: function (threadId, rate, options) {
            return exports.MessageThreadsApiFp(configuration).apiV1ThreadsByThreadIdRatePost(threadId, rate, options)(axios, basePath);
        },
        /**
         *
         * @summary This method requests rating.
         * @param {string} threadId
         * @param {MessageThreadBase} [messageThread]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdRaterequestPost: function (threadId, messageThread, options) {
            return exports.MessageThreadsApiFp(configuration).apiV1ThreadsByThreadIdRaterequestPost(threadId, messageThread, options)(axios, basePath);
        },
        /**
         *
         * @summary Get replies by thread id ordered by created dateTime.
         * @param {string} threadId
         * @param {number} [index]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdRepliesGet: function (threadId, index, options) {
            return exports.MessageThreadsApiFp(configuration).apiV1ThreadsByThreadIdRepliesGet(threadId, index, options)(axios, basePath);
        },
        /**
         *
         * @summary This method performs message reply post.
         * @param {string} threadId
         * @param {CreateMessageReply} [messageReplyToCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdRepliesPost: function (threadId, messageReplyToCreate, options) {
            return exports.MessageThreadsApiFp(configuration).apiV1ThreadsByThreadIdRepliesPost(threadId, messageReplyToCreate, options)(axios, basePath);
        },
        /**
         *
         * @summary Update the ResponderProgressStatus for the thread with the provided threadId
         * @param {string} threadId
         * @param {string} statusKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsByThreadIdStatusByStatusKeyPost: function (threadId, statusKey, options) {
            return exports.MessageThreadsApiFp(configuration).apiV1ThreadsByThreadIdStatusByStatusKeyPost(threadId, statusKey, options)(axios, basePath);
        },
        /**
         *
         * @summary Returning list of threads.
         * @param {'All' | 'Active' | 'NotResponded' | 'Closed'} [messageThreadStatus]
         * @param {'IncomingRequest' | 'OutgoingQuery'} [messageThreadDirection]
         * @param {string} [documentNumber]
         * @param {'Invoice' | 'CreditNote' | 'Order' | 'RemittanceAdvice' | 'Unspecified'} [documentType]
         * @param {string} [responder]
         * @param {string} [initiator]
         * @param {Date} [createdFromTime]
         * @param {Date} [createdToTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsFilteredGet: function (messageThreadStatus, messageThreadDirection, documentNumber, documentType, responder, initiator, createdFromTime, createdToTime, options) {
            return exports.MessageThreadsApiFp(configuration).apiV1ThreadsFilteredGet(messageThreadStatus, messageThreadDirection, documentNumber, documentType, responder, initiator, createdFromTime, createdToTime, options)(axios, basePath);
        },
        /**
         *
         * @summary Returning list of threads.
         * @param {'All' | 'IncomingRequest' | 'OutgoingQuery'} [messageType]
         * @param {'All' | 'Bill' | 'Order'} [documentType]
         * @param {'User' | 'Department' | 'Company'} [messageScope]
         * @param {'All' | 'Active' | 'NotResponded' | 'Closed'} [messageThreadStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsGet: function (messageType, documentType, messageScope, messageThreadStatus, options) {
            return exports.MessageThreadsApiFp(configuration).apiV1ThreadsGet(messageType, documentType, messageScope, messageThreadStatus, options)(axios, basePath);
        },
        /**
         *
         * @summary Use this in order to post message thread.
         * @param {CreateComplaintMessageThread} [messageThreadToCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ThreadsPost: function (messageThreadToCreate, options) {
            return exports.MessageThreadsApiFp(configuration).apiV1ThreadsPost(messageThreadToCreate, options)(axios, basePath);
        },
    };
};
/**
 * MessageThreadsApi - object-oriented interface
 * @export
 * @class MessageThreadsApi
 * @extends {BaseAPI}
 */
var MessageThreadsApi = /** @class */ (function (_super) {
    __extends(MessageThreadsApi, _super);
    function MessageThreadsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary This method marks a thread as closed and optionally gives rating.
     * @param {string} threadId
     * @param {MessageThreadRate} [rate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageThreadsApi
     */
    MessageThreadsApi.prototype.apiV1ThreadsByThreadIdCloseandratePut = function (threadId, rate, options) {
        return exports.MessageThreadsApiFp(this.configuration).apiV1ThreadsByThreadIdCloseandratePut(threadId, rate, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary This method requests closing.
     * @param {string} threadId
     * @param {MessageThreadBase} [messageThread]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageThreadsApi
     */
    MessageThreadsApi.prototype.apiV1ThreadsByThreadIdCloserequestPost = function (threadId, messageThread, options) {
        return exports.MessageThreadsApiFp(this.configuration).apiV1ThreadsByThreadIdCloserequestPost(threadId, messageThread, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returning a thread view by thread id.
     * @param {string} threadId
     * @param {string} [markAsRead]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageThreadsApi
     */
    MessageThreadsApi.prototype.apiV1ThreadsByThreadIdGet = function (threadId, markAsRead, options) {
        return exports.MessageThreadsApiFp(this.configuration).apiV1ThreadsByThreadIdGet(threadId, markAsRead, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} threadId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageThreadsApi
     */
    MessageThreadsApi.prototype.apiV1ThreadsByThreadIdLinkedDocumentsGet = function (threadId, options) {
        return exports.MessageThreadsApiFp(this.configuration).apiV1ThreadsByThreadIdLinkedDocumentsGet(threadId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returning a thread view by thread id.
     * @param {string} threadId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageThreadsApi
     */
    MessageThreadsApi.prototype.apiV1ThreadsByThreadIdParticipantsGet = function (threadId, options) {
        return exports.MessageThreadsApiFp(this.configuration).apiV1ThreadsByThreadIdParticipantsGet(threadId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary This method gives rating.
     * @param {string} threadId
     * @param {MessageThreadRate} [rate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageThreadsApi
     */
    MessageThreadsApi.prototype.apiV1ThreadsByThreadIdRatePost = function (threadId, rate, options) {
        return exports.MessageThreadsApiFp(this.configuration).apiV1ThreadsByThreadIdRatePost(threadId, rate, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary This method requests rating.
     * @param {string} threadId
     * @param {MessageThreadBase} [messageThread]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageThreadsApi
     */
    MessageThreadsApi.prototype.apiV1ThreadsByThreadIdRaterequestPost = function (threadId, messageThread, options) {
        return exports.MessageThreadsApiFp(this.configuration).apiV1ThreadsByThreadIdRaterequestPost(threadId, messageThread, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get replies by thread id ordered by created dateTime.
     * @param {string} threadId
     * @param {number} [index]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageThreadsApi
     */
    MessageThreadsApi.prototype.apiV1ThreadsByThreadIdRepliesGet = function (threadId, index, options) {
        return exports.MessageThreadsApiFp(this.configuration).apiV1ThreadsByThreadIdRepliesGet(threadId, index, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary This method performs message reply post.
     * @param {string} threadId
     * @param {CreateMessageReply} [messageReplyToCreate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageThreadsApi
     */
    MessageThreadsApi.prototype.apiV1ThreadsByThreadIdRepliesPost = function (threadId, messageReplyToCreate, options) {
        return exports.MessageThreadsApiFp(this.configuration).apiV1ThreadsByThreadIdRepliesPost(threadId, messageReplyToCreate, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Update the ResponderProgressStatus for the thread with the provided threadId
     * @param {string} threadId
     * @param {string} statusKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageThreadsApi
     */
    MessageThreadsApi.prototype.apiV1ThreadsByThreadIdStatusByStatusKeyPost = function (threadId, statusKey, options) {
        return exports.MessageThreadsApiFp(this.configuration).apiV1ThreadsByThreadIdStatusByStatusKeyPost(threadId, statusKey, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returning list of threads.
     * @param {'All' | 'Active' | 'NotResponded' | 'Closed'} [messageThreadStatus]
     * @param {'IncomingRequest' | 'OutgoingQuery'} [messageThreadDirection]
     * @param {string} [documentNumber]
     * @param {'Invoice' | 'CreditNote' | 'Order' | 'RemittanceAdvice' | 'Unspecified'} [documentType]
     * @param {string} [responder]
     * @param {string} [initiator]
     * @param {Date} [createdFromTime]
     * @param {Date} [createdToTime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageThreadsApi
     */
    MessageThreadsApi.prototype.apiV1ThreadsFilteredGet = function (messageThreadStatus, messageThreadDirection, documentNumber, documentType, responder, initiator, createdFromTime, createdToTime, options) {
        return exports.MessageThreadsApiFp(this.configuration).apiV1ThreadsFilteredGet(messageThreadStatus, messageThreadDirection, documentNumber, documentType, responder, initiator, createdFromTime, createdToTime, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returning list of threads.
     * @param {'All' | 'IncomingRequest' | 'OutgoingQuery'} [messageType]
     * @param {'All' | 'Bill' | 'Order'} [documentType]
     * @param {'User' | 'Department' | 'Company'} [messageScope]
     * @param {'All' | 'Active' | 'NotResponded' | 'Closed'} [messageThreadStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageThreadsApi
     */
    MessageThreadsApi.prototype.apiV1ThreadsGet = function (messageType, documentType, messageScope, messageThreadStatus, options) {
        return exports.MessageThreadsApiFp(this.configuration).apiV1ThreadsGet(messageType, documentType, messageScope, messageThreadStatus, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Use this in order to post message thread.
     * @param {CreateComplaintMessageThread} [messageThreadToCreate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageThreadsApi
     */
    MessageThreadsApi.prototype.apiV1ThreadsPost = function (messageThreadToCreate, options) {
        return exports.MessageThreadsApiFp(this.configuration).apiV1ThreadsPost(messageThreadToCreate, options)(this.axios, this.basePath);
    };
    return MessageThreadsApi;
}(base_1.BaseAPI));
exports.MessageThreadsApi = MessageThreadsApi;
/**
 * ParametersApi - axios parameter creator
 * @export
 */
exports.ParametersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Just creating TypeScript interfaces in Swagger
         * @param {ThreadAdvancedSearchOptions} [threadAdvancedSearchOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ParametersinterfacegenerationPost: function (threadAdvancedSearchOptions, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/parametersinterfacegeneration";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof threadAdvancedSearchOptions !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(threadAdvancedSearchOptions !== undefined ? threadAdvancedSearchOptions : {}) : (threadAdvancedSearchOptions || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ParametersApi - functional programming interface
 * @export
 */
exports.ParametersApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Just creating TypeScript interfaces in Swagger
         * @param {ThreadAdvancedSearchOptions} [threadAdvancedSearchOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ParametersinterfacegenerationPost: function (threadAdvancedSearchOptions, options) {
            var localVarAxiosArgs = exports.ParametersApiAxiosParamCreator(configuration).apiV1ParametersinterfacegenerationPost(threadAdvancedSearchOptions, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ParametersApi - factory interface
 * @export
 */
exports.ParametersApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Just creating TypeScript interfaces in Swagger
         * @param {ThreadAdvancedSearchOptions} [threadAdvancedSearchOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ParametersinterfacegenerationPost: function (threadAdvancedSearchOptions, options) {
            return exports.ParametersApiFp(configuration).apiV1ParametersinterfacegenerationPost(threadAdvancedSearchOptions, options)(axios, basePath);
        },
    };
};
/**
 * ParametersApi - object-oriented interface
 * @export
 * @class ParametersApi
 * @extends {BaseAPI}
 */
var ParametersApi = /** @class */ (function (_super) {
    __extends(ParametersApi, _super);
    function ParametersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Just creating TypeScript interfaces in Swagger
     * @param {ThreadAdvancedSearchOptions} [threadAdvancedSearchOptions]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParametersApi
     */
    ParametersApi.prototype.apiV1ParametersinterfacegenerationPost = function (threadAdvancedSearchOptions, options) {
        return exports.ParametersApiFp(this.configuration).apiV1ParametersinterfacegenerationPost(threadAdvancedSearchOptions, options)(this.axios, this.basePath);
    };
    return ParametersApi;
}(base_1.BaseAPI));
exports.ParametersApi = ParametersApi;
/**
 * ParticipantsApi - axios parameter creator
 * @export
 */
exports.ParticipantsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete customer contact information, associated with the customer.
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnnouncementsCustomersByLegalIsoIdentifierDelete: function (legalIsoIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'legalIsoIdentifier' is not null or undefined
            if (legalIsoIdentifier === null || legalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier', 'Required parameter legalIsoIdentifier was null or undefined when calling apiV1AnnouncementsCustomersByLegalIsoIdentifierDelete.');
            }
            var localVarPath = "/api/v1/announcements/customers/{legalIsoIdentifier}"
                .replace("{" + "legalIsoIdentifier" + "}", encodeURIComponent(String(legalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a single customer, with contact information (name and e-mail) from the announcement contacts.
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnnouncementsCustomersByLegalIsoIdentifierGet: function (legalIsoIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'legalIsoIdentifier' is not null or undefined
            if (legalIsoIdentifier === null || legalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier', 'Required parameter legalIsoIdentifier was null or undefined when calling apiV1AnnouncementsCustomersByLegalIsoIdentifierGet.');
            }
            var localVarPath = "/api/v1/announcements/customers/{legalIsoIdentifier}"
                .replace("{" + "legalIsoIdentifier" + "}", encodeURIComponent(String(legalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Updates customer contact information, associated with the customer.  <param name=\"legalIsoIdentifier\"></param><param name=\"participant\"></param>
         * @param {string} legalIsoIdentifier
         * @param {string} legalIsoIdentifier2
         * @param {string} [contactName]
         * @param {string} [contactEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnnouncementsCustomersByLegalIsoIdentifierPut: function (legalIsoIdentifier, legalIsoIdentifier2, contactName, contactEmail, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'legalIsoIdentifier' is not null or undefined
            if (legalIsoIdentifier === null || legalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier', 'Required parameter legalIsoIdentifier was null or undefined when calling apiV1AnnouncementsCustomersByLegalIsoIdentifierPut.');
            }
            // verify required parameter 'legalIsoIdentifier2' is not null or undefined
            if (legalIsoIdentifier2 === null || legalIsoIdentifier2 === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier2', 'Required parameter legalIsoIdentifier2 was null or undefined when calling apiV1AnnouncementsCustomersByLegalIsoIdentifierPut.');
            }
            var localVarPath = "/api/v1/announcements/customers/{legalIsoIdentifier}"
                .replace("{" + "legalIsoIdentifier" + "}", encodeURIComponent(String(legalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (legalIsoIdentifier2 !== undefined) {
                localVarQueryParameter['LegalIsoIdentifier'] = legalIsoIdentifier2;
            }
            if (contactName !== undefined) {
                localVarQueryParameter['ContactName'] = contactName;
            }
            if (contactEmail !== undefined) {
                localVarQueryParameter['ContactEmail'] = contactEmail;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a list of customers, with contact information (name and e-mail) from the announcement contacts.
         * @param {string} [tagName]
         * @param {string} [textFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnnouncementsCustomersGet: function (tagName, textFilter, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/announcements/customers";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (tagName !== undefined) {
                localVarQueryParameter['TagName'] = tagName;
            }
            if (textFilter !== undefined) {
                localVarQueryParameter['TextFilter'] = textFilter;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Creates contact information, associated with the customer.
         * @param {string} legalIsoIdentifier
         * @param {string} [contactName]
         * @param {string} [contactEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnnouncementsCustomersPost: function (legalIsoIdentifier, contactName, contactEmail, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'legalIsoIdentifier' is not null or undefined
            if (legalIsoIdentifier === null || legalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier', 'Required parameter legalIsoIdentifier was null or undefined when calling apiV1AnnouncementsCustomersPost.');
            }
            var localVarPath = "/api/v1/announcements/customers";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (legalIsoIdentifier !== undefined) {
                localVarQueryParameter['LegalIsoIdentifier'] = legalIsoIdentifier;
            }
            if (contactName !== undefined) {
                localVarQueryParameter['ContactName'] = contactName;
            }
            if (contactEmail !== undefined) {
                localVarQueryParameter['ContactEmail'] = contactEmail;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns a list of participants send/receive capabilities grouped by document type.
         * @param {string} participantIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CapabilitiesGet: function (participantIsoIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'participantIsoIdentifier' is not null or undefined
            if (participantIsoIdentifier === null || participantIsoIdentifier === undefined) {
                throw new base_1.RequiredError('participantIsoIdentifier', 'Required parameter participantIsoIdentifier was null or undefined when calling apiV1CapabilitiesGet.');
            }
            var localVarPath = "/api/v1/capabilities";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (participantIsoIdentifier !== undefined) {
                localVarQueryParameter['ParticipantIsoIdentifier'] = participantIsoIdentifier;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a customer relationship, marks it as not visible if it exists.
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByLegalIsoIdentifierDelete: function (legalIsoIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'legalIsoIdentifier' is not null or undefined
            if (legalIsoIdentifier === null || legalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier', 'Required parameter legalIsoIdentifier was null or undefined when calling apiV1CustomersByLegalIsoIdentifierDelete.');
            }
            var localVarPath = "/api/v1/customers/{legalIsoIdentifier}"
                .replace("{" + "legalIsoIdentifier" + "}", encodeURIComponent(String(legalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a specific customer (by relation to participants)&gt;
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByLegalIsoIdentifierGet: function (legalIsoIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'legalIsoIdentifier' is not null or undefined
            if (legalIsoIdentifier === null || legalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier', 'Required parameter legalIsoIdentifier was null or undefined when calling apiV1CustomersByLegalIsoIdentifierGet.');
            }
            var localVarPath = "/api/v1/customers/{legalIsoIdentifier}"
                .replace("{" + "legalIsoIdentifier" + "}", encodeURIComponent(String(legalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Updates a customer relationship, marks it as visible if it was not already.
         * @param {string} legalIsoIdentifier
         * @param {string} [legalIsoIdentifier2]
         * @param {string} [legalName]
         * @param {string} [legalAddressStreet]
         * @param {string} [legalAddressCity]
         * @param {string} [legalAddressPostalCode]
         * @param {string} [legalAddressCountry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByLegalIsoIdentifierPut: function (legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'legalIsoIdentifier' is not null or undefined
            if (legalIsoIdentifier === null || legalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier', 'Required parameter legalIsoIdentifier was null or undefined when calling apiV1CustomersByLegalIsoIdentifierPut.');
            }
            var localVarPath = "/api/v1/customers/{legalIsoIdentifier}"
                .replace("{" + "legalIsoIdentifier" + "}", encodeURIComponent(String(legalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (legalIsoIdentifier2 !== undefined) {
                localVarQueryParameter['LegalIsoIdentifier'] = legalIsoIdentifier2;
            }
            if (legalName !== undefined) {
                localVarQueryParameter['LegalName'] = legalName;
            }
            if (legalAddressStreet !== undefined) {
                localVarQueryParameter['LegalAddressStreet'] = legalAddressStreet;
            }
            if (legalAddressCity !== undefined) {
                localVarQueryParameter['LegalAddressCity'] = legalAddressCity;
            }
            if (legalAddressPostalCode !== undefined) {
                localVarQueryParameter['LegalAddressPostalCode'] = legalAddressPostalCode;
            }
            if (legalAddressCountry !== undefined) {
                localVarQueryParameter['LegalAddressCountry'] = legalAddressCountry;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a filtered, paged list of customers (by relations to participants).
         * @param {string} [isoIdentifier]
         * @param {string} [customerName]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersGet: function (isoIdentifier, customerName, address, city, textFilter, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/customers";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (isoIdentifier !== undefined) {
                localVarQueryParameter['IsoIdentifier'] = isoIdentifier;
            }
            if (customerName !== undefined) {
                localVarQueryParameter['CustomerName'] = customerName;
            }
            if (address !== undefined) {
                localVarQueryParameter['Address'] = address;
            }
            if (city !== undefined) {
                localVarQueryParameter['City'] = city;
            }
            if (textFilter !== undefined) {
                localVarQueryParameter['TextFilter'] = textFilter;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Creates a new customer, by adding a participant relation. Customer data is added, if the participant currently does not exist, otherwise it is overriden.
         * @param {string} [legalIsoIdentifier]
         * @param {string} [legalName]
         * @param {string} [legalAddressStreet]
         * @param {string} [legalAddressCity]
         * @param {string} [legalAddressPostalCode]
         * @param {string} [legalAddressCountry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersPost: function (legalIsoIdentifier, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/customers";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (legalIsoIdentifier !== undefined) {
                localVarQueryParameter['LegalIsoIdentifier'] = legalIsoIdentifier;
            }
            if (legalName !== undefined) {
                localVarQueryParameter['LegalName'] = legalName;
            }
            if (legalAddressStreet !== undefined) {
                localVarQueryParameter['LegalAddressStreet'] = legalAddressStreet;
            }
            if (legalAddressCity !== undefined) {
                localVarQueryParameter['LegalAddressCity'] = legalAddressCity;
            }
            if (legalAddressPostalCode !== undefined) {
                localVarQueryParameter['LegalAddressPostalCode'] = legalAddressPostalCode;
            }
            if (legalAddressCountry !== undefined) {
                localVarQueryParameter['LegalAddressCountry'] = legalAddressCountry;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns a list of participants with additional details related to documents and transactions.
         * @param {string} role
         * @param {'Invoice' | 'CreditNote' | 'Order' | 'RemittanceAdvice' | 'Unspecified'} [documentType]
         * @param {Array<TransactionRolesQueryParticipantInput>} [participants]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GetTransactionrolesPost: function (role, documentType, participants, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'role' is not null or undefined
            if (role === null || role === undefined) {
                throw new base_1.RequiredError('role', 'Required parameter role was null or undefined when calling apiV1GetTransactionrolesPost.');
            }
            var localVarPath = "/api/v1/get-transactionroles";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (documentType !== undefined) {
                localVarQueryParameter['DocumentType'] = documentType;
            }
            if (role !== undefined) {
                localVarQueryParameter['Role'] = role;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof participants !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(participants !== undefined ? participants : {}) : (participants || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all participant roles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ParticipantRolesGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/participant-roles";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Searches the profiles of your business partners (suppliers, customers, transport companies that you do business with) by name
         * @param {string} [nameFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnersGet: function (nameFilter, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/partners";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (nameFilter !== undefined) {
                localVarQueryParameter['nameFilter'] = nameFilter;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [legalIsoIdentifier]
         * @param {string} [legalIsoIdentifier2]
         * @param {string} [legalName]
         * @param {string} [legalAddressStreet]
         * @param {string} [legalAddressCity]
         * @param {string} [legalAddressPostalCode]
         * @param {string} [legalAddressCountry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersByIdPut: function (id, legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling apiV1SuppliersByIdPut.');
            }
            var localVarPath = "/api/v1/suppliers/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (legalIsoIdentifier !== undefined) {
                localVarQueryParameter['legalIsoIdentifier'] = legalIsoIdentifier;
            }
            if (legalIsoIdentifier2 !== undefined) {
                localVarQueryParameter['LegalIsoIdentifier'] = legalIsoIdentifier2;
            }
            if (legalName !== undefined) {
                localVarQueryParameter['LegalName'] = legalName;
            }
            if (legalAddressStreet !== undefined) {
                localVarQueryParameter['LegalAddressStreet'] = legalAddressStreet;
            }
            if (legalAddressCity !== undefined) {
                localVarQueryParameter['LegalAddressCity'] = legalAddressCity;
            }
            if (legalAddressPostalCode !== undefined) {
                localVarQueryParameter['LegalAddressPostalCode'] = legalAddressPostalCode;
            }
            if (legalAddressCountry !== undefined) {
                localVarQueryParameter['LegalAddressCountry'] = legalAddressCountry;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} legalIsoIdentifier
         * @param {string} [legalIsoIdentifier2]
         * @param {string} [legalName]
         * @param {string} [legalAddressStreet]
         * @param {string} [legalAddressCity]
         * @param {string} [legalAddressPostalCode]
         * @param {string} [legalAddressCountry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersByLegalIsoIdentifierDelete: function (legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'legalIsoIdentifier' is not null or undefined
            if (legalIsoIdentifier === null || legalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier', 'Required parameter legalIsoIdentifier was null or undefined when calling apiV1SuppliersByLegalIsoIdentifierDelete.');
            }
            var localVarPath = "/api/v1/suppliers/{legalIsoIdentifier}"
                .replace("{" + "legalIsoIdentifier" + "}", encodeURIComponent(String(legalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (legalIsoIdentifier2 !== undefined) {
                localVarQueryParameter['LegalIsoIdentifier'] = legalIsoIdentifier2;
            }
            if (legalName !== undefined) {
                localVarQueryParameter['LegalName'] = legalName;
            }
            if (legalAddressStreet !== undefined) {
                localVarQueryParameter['LegalAddressStreet'] = legalAddressStreet;
            }
            if (legalAddressCity !== undefined) {
                localVarQueryParameter['LegalAddressCity'] = legalAddressCity;
            }
            if (legalAddressPostalCode !== undefined) {
                localVarQueryParameter['LegalAddressPostalCode'] = legalAddressPostalCode;
            }
            if (legalAddressCountry !== undefined) {
                localVarQueryParameter['LegalAddressCountry'] = legalAddressCountry;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a specific supplier (by relation to participants)&gt;
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersByLegalIsoIdentifierGet: function (legalIsoIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'legalIsoIdentifier' is not null or undefined
            if (legalIsoIdentifier === null || legalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier', 'Required parameter legalIsoIdentifier was null or undefined when calling apiV1SuppliersByLegalIsoIdentifierGet.');
            }
            var localVarPath = "/api/v1/suppliers/{legalIsoIdentifier}"
                .replace("{" + "legalIsoIdentifier" + "}", encodeURIComponent(String(legalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a filtered, paged list of suppliers (by relations to participants).
         * @param {string} [isoIdentifier]
         * @param {string} [customerName]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersGet: function (isoIdentifier, customerName, address, city, textFilter, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/suppliers";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (isoIdentifier !== undefined) {
                localVarQueryParameter['IsoIdentifier'] = isoIdentifier;
            }
            if (customerName !== undefined) {
                localVarQueryParameter['CustomerName'] = customerName;
            }
            if (address !== undefined) {
                localVarQueryParameter['Address'] = address;
            }
            if (city !== undefined) {
                localVarQueryParameter['City'] = city;
            }
            if (textFilter !== undefined) {
                localVarQueryParameter['TextFilter'] = textFilter;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [legalIsoIdentifier]
         * @param {string} [legalName]
         * @param {string} [legalAddressStreet]
         * @param {string} [legalAddressCity]
         * @param {string} [legalAddressPostalCode]
         * @param {string} [legalAddressCountry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersPost: function (legalIsoIdentifier, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/suppliers";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (legalIsoIdentifier !== undefined) {
                localVarQueryParameter['LegalIsoIdentifier'] = legalIsoIdentifier;
            }
            if (legalName !== undefined) {
                localVarQueryParameter['LegalName'] = legalName;
            }
            if (legalAddressStreet !== undefined) {
                localVarQueryParameter['LegalAddressStreet'] = legalAddressStreet;
            }
            if (legalAddressCity !== undefined) {
                localVarQueryParameter['LegalAddressCity'] = legalAddressCity;
            }
            if (legalAddressPostalCode !== undefined) {
                localVarQueryParameter['LegalAddressPostalCode'] = legalAddressPostalCode;
            }
            if (legalAddressCountry !== undefined) {
                localVarQueryParameter['LegalAddressCountry'] = legalAddressCountry;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ParticipantsApi - functional programming interface
 * @export
 */
exports.ParticipantsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Delete customer contact information, associated with the customer.
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnnouncementsCustomersByLegalIsoIdentifierDelete: function (legalIsoIdentifier, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1AnnouncementsCustomersByLegalIsoIdentifierDelete(legalIsoIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get a single customer, with contact information (name and e-mail) from the announcement contacts.
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnnouncementsCustomersByLegalIsoIdentifierGet: function (legalIsoIdentifier, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1AnnouncementsCustomersByLegalIsoIdentifierGet(legalIsoIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Updates customer contact information, associated with the customer.  <param name=\"legalIsoIdentifier\"></param><param name=\"participant\"></param>
         * @param {string} legalIsoIdentifier
         * @param {string} legalIsoIdentifier2
         * @param {string} [contactName]
         * @param {string} [contactEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnnouncementsCustomersByLegalIsoIdentifierPut: function (legalIsoIdentifier, legalIsoIdentifier2, contactName, contactEmail, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1AnnouncementsCustomersByLegalIsoIdentifierPut(legalIsoIdentifier, legalIsoIdentifier2, contactName, contactEmail, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets a list of customers, with contact information (name and e-mail) from the announcement contacts.
         * @param {string} [tagName]
         * @param {string} [textFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnnouncementsCustomersGet: function (tagName, textFilter, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1AnnouncementsCustomersGet(tagName, textFilter, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Creates contact information, associated with the customer.
         * @param {string} legalIsoIdentifier
         * @param {string} [contactName]
         * @param {string} [contactEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnnouncementsCustomersPost: function (legalIsoIdentifier, contactName, contactEmail, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1AnnouncementsCustomersPost(legalIsoIdentifier, contactName, contactEmail, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returns a list of participants send/receive capabilities grouped by document type.
         * @param {string} participantIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CapabilitiesGet: function (participantIsoIdentifier, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1CapabilitiesGet(participantIsoIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Delete a customer relationship, marks it as not visible if it exists.
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByLegalIsoIdentifierDelete: function (legalIsoIdentifier, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1CustomersByLegalIsoIdentifierDelete(legalIsoIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets a specific customer (by relation to participants)&gt;
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByLegalIsoIdentifierGet: function (legalIsoIdentifier, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1CustomersByLegalIsoIdentifierGet(legalIsoIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Updates a customer relationship, marks it as visible if it was not already.
         * @param {string} legalIsoIdentifier
         * @param {string} [legalIsoIdentifier2]
         * @param {string} [legalName]
         * @param {string} [legalAddressStreet]
         * @param {string} [legalAddressCity]
         * @param {string} [legalAddressPostalCode]
         * @param {string} [legalAddressCountry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByLegalIsoIdentifierPut: function (legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1CustomersByLegalIsoIdentifierPut(legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets a filtered, paged list of customers (by relations to participants).
         * @param {string} [isoIdentifier]
         * @param {string} [customerName]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersGet: function (isoIdentifier, customerName, address, city, textFilter, offset, limit, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1CustomersGet(isoIdentifier, customerName, address, city, textFilter, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Creates a new customer, by adding a participant relation. Customer data is added, if the participant currently does not exist, otherwise it is overriden.
         * @param {string} [legalIsoIdentifier]
         * @param {string} [legalName]
         * @param {string} [legalAddressStreet]
         * @param {string} [legalAddressCity]
         * @param {string} [legalAddressPostalCode]
         * @param {string} [legalAddressCountry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersPost: function (legalIsoIdentifier, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1CustomersPost(legalIsoIdentifier, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returns a list of participants with additional details related to documents and transactions.
         * @param {string} role
         * @param {'Invoice' | 'CreditNote' | 'Order' | 'RemittanceAdvice' | 'Unspecified'} [documentType]
         * @param {Array<TransactionRolesQueryParticipantInput>} [participants]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GetTransactionrolesPost: function (role, documentType, participants, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1GetTransactionrolesPost(role, documentType, participants, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all participant roles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ParticipantRolesGet: function (options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1ParticipantRolesGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Searches the profiles of your business partners (suppliers, customers, transport companies that you do business with) by name
         * @param {string} [nameFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnersGet: function (nameFilter, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1PartnersGet(nameFilter, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [legalIsoIdentifier]
         * @param {string} [legalIsoIdentifier2]
         * @param {string} [legalName]
         * @param {string} [legalAddressStreet]
         * @param {string} [legalAddressCity]
         * @param {string} [legalAddressPostalCode]
         * @param {string} [legalAddressCountry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersByIdPut: function (id, legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1SuppliersByIdPut(id, legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} legalIsoIdentifier
         * @param {string} [legalIsoIdentifier2]
         * @param {string} [legalName]
         * @param {string} [legalAddressStreet]
         * @param {string} [legalAddressCity]
         * @param {string} [legalAddressPostalCode]
         * @param {string} [legalAddressCountry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersByLegalIsoIdentifierDelete: function (legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1SuppliersByLegalIsoIdentifierDelete(legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets a specific supplier (by relation to participants)&gt;
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersByLegalIsoIdentifierGet: function (legalIsoIdentifier, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1SuppliersByLegalIsoIdentifierGet(legalIsoIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets a filtered, paged list of suppliers (by relations to participants).
         * @param {string} [isoIdentifier]
         * @param {string} [customerName]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersGet: function (isoIdentifier, customerName, address, city, textFilter, offset, limit, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1SuppliersGet(isoIdentifier, customerName, address, city, textFilter, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} [legalIsoIdentifier]
         * @param {string} [legalName]
         * @param {string} [legalAddressStreet]
         * @param {string} [legalAddressCity]
         * @param {string} [legalAddressPostalCode]
         * @param {string} [legalAddressCountry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersPost: function (legalIsoIdentifier, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).apiV1SuppliersPost(legalIsoIdentifier, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ParticipantsApi - factory interface
 * @export
 */
exports.ParticipantsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Delete customer contact information, associated with the customer.
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnnouncementsCustomersByLegalIsoIdentifierDelete: function (legalIsoIdentifier, options) {
            return exports.ParticipantsApiFp(configuration).apiV1AnnouncementsCustomersByLegalIsoIdentifierDelete(legalIsoIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @summary Get a single customer, with contact information (name and e-mail) from the announcement contacts.
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnnouncementsCustomersByLegalIsoIdentifierGet: function (legalIsoIdentifier, options) {
            return exports.ParticipantsApiFp(configuration).apiV1AnnouncementsCustomersByLegalIsoIdentifierGet(legalIsoIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @summary Updates customer contact information, associated with the customer.  <param name=\"legalIsoIdentifier\"></param><param name=\"participant\"></param>
         * @param {string} legalIsoIdentifier
         * @param {string} legalIsoIdentifier2
         * @param {string} [contactName]
         * @param {string} [contactEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnnouncementsCustomersByLegalIsoIdentifierPut: function (legalIsoIdentifier, legalIsoIdentifier2, contactName, contactEmail, options) {
            return exports.ParticipantsApiFp(configuration).apiV1AnnouncementsCustomersByLegalIsoIdentifierPut(legalIsoIdentifier, legalIsoIdentifier2, contactName, contactEmail, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets a list of customers, with contact information (name and e-mail) from the announcement contacts.
         * @param {string} [tagName]
         * @param {string} [textFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnnouncementsCustomersGet: function (tagName, textFilter, options) {
            return exports.ParticipantsApiFp(configuration).apiV1AnnouncementsCustomersGet(tagName, textFilter, options)(axios, basePath);
        },
        /**
         *
         * @summary Creates contact information, associated with the customer.
         * @param {string} legalIsoIdentifier
         * @param {string} [contactName]
         * @param {string} [contactEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AnnouncementsCustomersPost: function (legalIsoIdentifier, contactName, contactEmail, options) {
            return exports.ParticipantsApiFp(configuration).apiV1AnnouncementsCustomersPost(legalIsoIdentifier, contactName, contactEmail, options)(axios, basePath);
        },
        /**
         *
         * @summary Returns a list of participants send/receive capabilities grouped by document type.
         * @param {string} participantIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CapabilitiesGet: function (participantIsoIdentifier, options) {
            return exports.ParticipantsApiFp(configuration).apiV1CapabilitiesGet(participantIsoIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @summary Delete a customer relationship, marks it as not visible if it exists.
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByLegalIsoIdentifierDelete: function (legalIsoIdentifier, options) {
            return exports.ParticipantsApiFp(configuration).apiV1CustomersByLegalIsoIdentifierDelete(legalIsoIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets a specific customer (by relation to participants)&gt;
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByLegalIsoIdentifierGet: function (legalIsoIdentifier, options) {
            return exports.ParticipantsApiFp(configuration).apiV1CustomersByLegalIsoIdentifierGet(legalIsoIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @summary Updates a customer relationship, marks it as visible if it was not already.
         * @param {string} legalIsoIdentifier
         * @param {string} [legalIsoIdentifier2]
         * @param {string} [legalName]
         * @param {string} [legalAddressStreet]
         * @param {string} [legalAddressCity]
         * @param {string} [legalAddressPostalCode]
         * @param {string} [legalAddressCountry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersByLegalIsoIdentifierPut: function (legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
            return exports.ParticipantsApiFp(configuration).apiV1CustomersByLegalIsoIdentifierPut(legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets a filtered, paged list of customers (by relations to participants).
         * @param {string} [isoIdentifier]
         * @param {string} [customerName]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersGet: function (isoIdentifier, customerName, address, city, textFilter, offset, limit, options) {
            return exports.ParticipantsApiFp(configuration).apiV1CustomersGet(isoIdentifier, customerName, address, city, textFilter, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @summary Creates a new customer, by adding a participant relation. Customer data is added, if the participant currently does not exist, otherwise it is overriden.
         * @param {string} [legalIsoIdentifier]
         * @param {string} [legalName]
         * @param {string} [legalAddressStreet]
         * @param {string} [legalAddressCity]
         * @param {string} [legalAddressPostalCode]
         * @param {string} [legalAddressCountry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CustomersPost: function (legalIsoIdentifier, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
            return exports.ParticipantsApiFp(configuration).apiV1CustomersPost(legalIsoIdentifier, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options)(axios, basePath);
        },
        /**
         *
         * @summary Returns a list of participants with additional details related to documents and transactions.
         * @param {string} role
         * @param {'Invoice' | 'CreditNote' | 'Order' | 'RemittanceAdvice' | 'Unspecified'} [documentType]
         * @param {Array<TransactionRolesQueryParticipantInput>} [participants]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GetTransactionrolesPost: function (role, documentType, participants, options) {
            return exports.ParticipantsApiFp(configuration).apiV1GetTransactionrolesPost(role, documentType, participants, options)(axios, basePath);
        },
        /**
         *
         * @summary Get all participant roles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ParticipantRolesGet: function (options) {
            return exports.ParticipantsApiFp(configuration).apiV1ParticipantRolesGet(options)(axios, basePath);
        },
        /**
         *
         * @summary Searches the profiles of your business partners (suppliers, customers, transport companies that you do business with) by name
         * @param {string} [nameFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnersGet: function (nameFilter, options) {
            return exports.ParticipantsApiFp(configuration).apiV1PartnersGet(nameFilter, options)(axios, basePath);
        },
        /**
         *
         * @param {string} id
         * @param {string} [legalIsoIdentifier]
         * @param {string} [legalIsoIdentifier2]
         * @param {string} [legalName]
         * @param {string} [legalAddressStreet]
         * @param {string} [legalAddressCity]
         * @param {string} [legalAddressPostalCode]
         * @param {string} [legalAddressCountry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersByIdPut: function (id, legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
            return exports.ParticipantsApiFp(configuration).apiV1SuppliersByIdPut(id, legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options)(axios, basePath);
        },
        /**
         *
         * @param {string} legalIsoIdentifier
         * @param {string} [legalIsoIdentifier2]
         * @param {string} [legalName]
         * @param {string} [legalAddressStreet]
         * @param {string} [legalAddressCity]
         * @param {string} [legalAddressPostalCode]
         * @param {string} [legalAddressCountry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersByLegalIsoIdentifierDelete: function (legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
            return exports.ParticipantsApiFp(configuration).apiV1SuppliersByLegalIsoIdentifierDelete(legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets a specific supplier (by relation to participants)&gt;
         * @param {string} legalIsoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersByLegalIsoIdentifierGet: function (legalIsoIdentifier, options) {
            return exports.ParticipantsApiFp(configuration).apiV1SuppliersByLegalIsoIdentifierGet(legalIsoIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets a filtered, paged list of suppliers (by relations to participants).
         * @param {string} [isoIdentifier]
         * @param {string} [customerName]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [textFilter]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersGet: function (isoIdentifier, customerName, address, city, textFilter, offset, limit, options) {
            return exports.ParticipantsApiFp(configuration).apiV1SuppliersGet(isoIdentifier, customerName, address, city, textFilter, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @param {string} [legalIsoIdentifier]
         * @param {string} [legalName]
         * @param {string} [legalAddressStreet]
         * @param {string} [legalAddressCity]
         * @param {string} [legalAddressPostalCode]
         * @param {string} [legalAddressCountry]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SuppliersPost: function (legalIsoIdentifier, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
            return exports.ParticipantsApiFp(configuration).apiV1SuppliersPost(legalIsoIdentifier, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options)(axios, basePath);
        },
    };
};
/**
 * ParticipantsApi - object-oriented interface
 * @export
 * @class ParticipantsApi
 * @extends {BaseAPI}
 */
var ParticipantsApi = /** @class */ (function (_super) {
    __extends(ParticipantsApi, _super);
    function ParticipantsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete customer contact information, associated with the customer.
     * @param {string} legalIsoIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1AnnouncementsCustomersByLegalIsoIdentifierDelete = function (legalIsoIdentifier, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1AnnouncementsCustomersByLegalIsoIdentifierDelete(legalIsoIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get a single customer, with contact information (name and e-mail) from the announcement contacts.
     * @param {string} legalIsoIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1AnnouncementsCustomersByLegalIsoIdentifierGet = function (legalIsoIdentifier, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1AnnouncementsCustomersByLegalIsoIdentifierGet(legalIsoIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Updates customer contact information, associated with the customer.  <param name=\"legalIsoIdentifier\"></param><param name=\"participant\"></param>
     * @param {string} legalIsoIdentifier
     * @param {string} legalIsoIdentifier2
     * @param {string} [contactName]
     * @param {string} [contactEmail]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1AnnouncementsCustomersByLegalIsoIdentifierPut = function (legalIsoIdentifier, legalIsoIdentifier2, contactName, contactEmail, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1AnnouncementsCustomersByLegalIsoIdentifierPut(legalIsoIdentifier, legalIsoIdentifier2, contactName, contactEmail, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets a list of customers, with contact information (name and e-mail) from the announcement contacts.
     * @param {string} [tagName]
     * @param {string} [textFilter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1AnnouncementsCustomersGet = function (tagName, textFilter, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1AnnouncementsCustomersGet(tagName, textFilter, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Creates contact information, associated with the customer.
     * @param {string} legalIsoIdentifier
     * @param {string} [contactName]
     * @param {string} [contactEmail]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1AnnouncementsCustomersPost = function (legalIsoIdentifier, contactName, contactEmail, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1AnnouncementsCustomersPost(legalIsoIdentifier, contactName, contactEmail, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returns a list of participants send/receive capabilities grouped by document type.
     * @param {string} participantIsoIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1CapabilitiesGet = function (participantIsoIdentifier, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1CapabilitiesGet(participantIsoIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Delete a customer relationship, marks it as not visible if it exists.
     * @param {string} legalIsoIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1CustomersByLegalIsoIdentifierDelete = function (legalIsoIdentifier, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1CustomersByLegalIsoIdentifierDelete(legalIsoIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets a specific customer (by relation to participants)&gt;
     * @param {string} legalIsoIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1CustomersByLegalIsoIdentifierGet = function (legalIsoIdentifier, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1CustomersByLegalIsoIdentifierGet(legalIsoIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Updates a customer relationship, marks it as visible if it was not already.
     * @param {string} legalIsoIdentifier
     * @param {string} [legalIsoIdentifier2]
     * @param {string} [legalName]
     * @param {string} [legalAddressStreet]
     * @param {string} [legalAddressCity]
     * @param {string} [legalAddressPostalCode]
     * @param {string} [legalAddressCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1CustomersByLegalIsoIdentifierPut = function (legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1CustomersByLegalIsoIdentifierPut(legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets a filtered, paged list of customers (by relations to participants).
     * @param {string} [isoIdentifier]
     * @param {string} [customerName]
     * @param {string} [address]
     * @param {string} [city]
     * @param {string} [textFilter]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1CustomersGet = function (isoIdentifier, customerName, address, city, textFilter, offset, limit, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1CustomersGet(isoIdentifier, customerName, address, city, textFilter, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Creates a new customer, by adding a participant relation. Customer data is added, if the participant currently does not exist, otherwise it is overriden.
     * @param {string} [legalIsoIdentifier]
     * @param {string} [legalName]
     * @param {string} [legalAddressStreet]
     * @param {string} [legalAddressCity]
     * @param {string} [legalAddressPostalCode]
     * @param {string} [legalAddressCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1CustomersPost = function (legalIsoIdentifier, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1CustomersPost(legalIsoIdentifier, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returns a list of participants with additional details related to documents and transactions.
     * @param {string} role
     * @param {'Invoice' | 'CreditNote' | 'Order' | 'RemittanceAdvice' | 'Unspecified'} [documentType]
     * @param {Array<TransactionRolesQueryParticipantInput>} [participants]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1GetTransactionrolesPost = function (role, documentType, participants, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1GetTransactionrolesPost(role, documentType, participants, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get all participant roles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1ParticipantRolesGet = function (options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1ParticipantRolesGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Searches the profiles of your business partners (suppliers, customers, transport companies that you do business with) by name
     * @param {string} [nameFilter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1PartnersGet = function (nameFilter, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1PartnersGet(nameFilter, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} id
     * @param {string} [legalIsoIdentifier]
     * @param {string} [legalIsoIdentifier2]
     * @param {string} [legalName]
     * @param {string} [legalAddressStreet]
     * @param {string} [legalAddressCity]
     * @param {string} [legalAddressPostalCode]
     * @param {string} [legalAddressCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1SuppliersByIdPut = function (id, legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1SuppliersByIdPut(id, legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} legalIsoIdentifier
     * @param {string} [legalIsoIdentifier2]
     * @param {string} [legalName]
     * @param {string} [legalAddressStreet]
     * @param {string} [legalAddressCity]
     * @param {string} [legalAddressPostalCode]
     * @param {string} [legalAddressCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1SuppliersByLegalIsoIdentifierDelete = function (legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1SuppliersByLegalIsoIdentifierDelete(legalIsoIdentifier, legalIsoIdentifier2, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets a specific supplier (by relation to participants)&gt;
     * @param {string} legalIsoIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1SuppliersByLegalIsoIdentifierGet = function (legalIsoIdentifier, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1SuppliersByLegalIsoIdentifierGet(legalIsoIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets a filtered, paged list of suppliers (by relations to participants).
     * @param {string} [isoIdentifier]
     * @param {string} [customerName]
     * @param {string} [address]
     * @param {string} [city]
     * @param {string} [textFilter]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1SuppliersGet = function (isoIdentifier, customerName, address, city, textFilter, offset, limit, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1SuppliersGet(isoIdentifier, customerName, address, city, textFilter, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} [legalIsoIdentifier]
     * @param {string} [legalName]
     * @param {string} [legalAddressStreet]
     * @param {string} [legalAddressCity]
     * @param {string} [legalAddressPostalCode]
     * @param {string} [legalAddressCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.apiV1SuppliersPost = function (legalIsoIdentifier, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options) {
        return exports.ParticipantsApiFp(this.configuration).apiV1SuppliersPost(legalIsoIdentifier, legalName, legalAddressStreet, legalAddressCity, legalAddressPostalCode, legalAddressCountry, options)(this.axios, this.basePath);
    };
    return ParticipantsApi;
}(base_1.BaseAPI));
exports.ParticipantsApi = ParticipantsApi;
/**
 * ProfileApi - axios parameter creator
 * @export
 */
exports.ProfileApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return a list of allowed actors within the context of profile [profileKey].
         * @param {string} profileKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ActorsByProfileKeyGet: function (profileKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'profileKey' is not null or undefined
            if (profileKey === null || profileKey === undefined) {
                throw new base_1.RequiredError('profileKey', 'Required parameter profileKey was null or undefined when calling apiV1ActorsByProfileKeyGet.');
            }
            var localVarPath = "/api/v1/actors/{profileKey}"
                .replace("{" + "profileKey" + "}", encodeURIComponent(String(profileKey)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns list of allowed actors overall
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ActorsGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/actors";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get profile by id
         * @param {string} id2
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByIdGet: function (id2, id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id2' is not null or undefined
            if (id2 === null || id2 === undefined) {
                throw new base_1.RequiredError('id2', 'Required parameter id2 was null or undefined when calling apiV1ProfilesByIdGet.');
            }
            var localVarPath = "/api/v1/profiles/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id2)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retunrs the icon image for provided profileId
         * @param {number} profileId
         * @param {string} [cacheKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByProfileIdIconGet: function (profileId, cacheKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'profileId' is not null or undefined
            if (profileId === null || profileId === undefined) {
                throw new base_1.RequiredError('profileId', 'Required parameter profileId was null or undefined when calling apiV1ProfilesByProfileIdIconGet.');
            }
            var localVarPath = "/api/v1/profiles/{profileId}/icon"
                .replace("{" + "profileId" + "}", encodeURIComponent(String(profileId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (cacheKey !== undefined) {
                localVarQueryParameter['cacheKey'] = cacheKey;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retunrs the logo image for provided profileId
         * @param {number} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByProfileIdLogoGet: function (profileId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'profileId' is not null or undefined
            if (profileId === null || profileId === undefined) {
                throw new base_1.RequiredError('profileId', 'Required parameter profileId was null or undefined when calling apiV1ProfilesByProfileIdLogoGet.');
            }
            var localVarPath = "/api/v1/profiles/{profileId}/logo"
                .replace("{" + "profileId" + "}", encodeURIComponent(String(profileId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns actors of logged in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesSelfActorsGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/profiles/self/actors";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns a full profile of logged in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesSelfGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/profiles/self";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Creates or updates the profile icon
         * @param {ChangeProfilePicture} [changeProfilePicture]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesSelfIconPut: function (changeProfilePicture, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/profiles/self/icon";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof changeProfilePicture !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(changeProfilePicture !== undefined ? changeProfilePicture : {}) : (changeProfilePicture || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Creates or updates the profile logo
         * @param {ChangeProfilePicture} [changeProfilePicture]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesSelfLogoPut: function (changeProfilePicture, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/profiles/self/logo";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof changeProfilePicture !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(changeProfilePicture !== undefined ? changeProfilePicture : {}) : (changeProfilePicture || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns entire profile by user name with list of allowed actors overall.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserProfilesGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/user/profiles";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns user context by user id with list of allowed actors overall.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserUsercontextGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/user/usercontext";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProfileApi - functional programming interface
 * @export
 */
exports.ProfileApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Return a list of allowed actors within the context of profile [profileKey].
         * @param {string} profileKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ActorsByProfileKeyGet: function (profileKey, options) {
            var localVarAxiosArgs = exports.ProfileApiAxiosParamCreator(configuration).apiV1ActorsByProfileKeyGet(profileKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returns list of allowed actors overall
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ActorsGet: function (options) {
            var localVarAxiosArgs = exports.ProfileApiAxiosParamCreator(configuration).apiV1ActorsGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get profile by id
         * @param {string} id2
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByIdGet: function (id2, id, options) {
            var localVarAxiosArgs = exports.ProfileApiAxiosParamCreator(configuration).apiV1ProfilesByIdGet(id2, id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Retunrs the icon image for provided profileId
         * @param {number} profileId
         * @param {string} [cacheKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByProfileIdIconGet: function (profileId, cacheKey, options) {
            var localVarAxiosArgs = exports.ProfileApiAxiosParamCreator(configuration).apiV1ProfilesByProfileIdIconGet(profileId, cacheKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Retunrs the logo image for provided profileId
         * @param {number} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByProfileIdLogoGet: function (profileId, options) {
            var localVarAxiosArgs = exports.ProfileApiAxiosParamCreator(configuration).apiV1ProfilesByProfileIdLogoGet(profileId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returns actors of logged in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesSelfActorsGet: function (options) {
            var localVarAxiosArgs = exports.ProfileApiAxiosParamCreator(configuration).apiV1ProfilesSelfActorsGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returns a full profile of logged in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesSelfGet: function (options) {
            var localVarAxiosArgs = exports.ProfileApiAxiosParamCreator(configuration).apiV1ProfilesSelfGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Creates or updates the profile icon
         * @param {ChangeProfilePicture} [changeProfilePicture]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesSelfIconPut: function (changeProfilePicture, options) {
            var localVarAxiosArgs = exports.ProfileApiAxiosParamCreator(configuration).apiV1ProfilesSelfIconPut(changeProfilePicture, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Creates or updates the profile logo
         * @param {ChangeProfilePicture} [changeProfilePicture]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesSelfLogoPut: function (changeProfilePicture, options) {
            var localVarAxiosArgs = exports.ProfileApiAxiosParamCreator(configuration).apiV1ProfilesSelfLogoPut(changeProfilePicture, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returns entire profile by user name with list of allowed actors overall.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserProfilesGet: function (options) {
            var localVarAxiosArgs = exports.ProfileApiAxiosParamCreator(configuration).apiV1UserProfilesGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returns user context by user id with list of allowed actors overall.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserUsercontextGet: function (options) {
            var localVarAxiosArgs = exports.ProfileApiAxiosParamCreator(configuration).apiV1UserUsercontextGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ProfileApi - factory interface
 * @export
 */
exports.ProfileApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Return a list of allowed actors within the context of profile [profileKey].
         * @param {string} profileKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ActorsByProfileKeyGet: function (profileKey, options) {
            return exports.ProfileApiFp(configuration).apiV1ActorsByProfileKeyGet(profileKey, options)(axios, basePath);
        },
        /**
         *
         * @summary Returns list of allowed actors overall
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ActorsGet: function (options) {
            return exports.ProfileApiFp(configuration).apiV1ActorsGet(options)(axios, basePath);
        },
        /**
         *
         * @summary Get profile by id
         * @param {string} id2
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByIdGet: function (id2, id, options) {
            return exports.ProfileApiFp(configuration).apiV1ProfilesByIdGet(id2, id, options)(axios, basePath);
        },
        /**
         *
         * @summary Retunrs the icon image for provided profileId
         * @param {number} profileId
         * @param {string} [cacheKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByProfileIdIconGet: function (profileId, cacheKey, options) {
            return exports.ProfileApiFp(configuration).apiV1ProfilesByProfileIdIconGet(profileId, cacheKey, options)(axios, basePath);
        },
        /**
         *
         * @summary Retunrs the logo image for provided profileId
         * @param {number} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesByProfileIdLogoGet: function (profileId, options) {
            return exports.ProfileApiFp(configuration).apiV1ProfilesByProfileIdLogoGet(profileId, options)(axios, basePath);
        },
        /**
         *
         * @summary Returns actors of logged in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesSelfActorsGet: function (options) {
            return exports.ProfileApiFp(configuration).apiV1ProfilesSelfActorsGet(options)(axios, basePath);
        },
        /**
         *
         * @summary Returns a full profile of logged in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesSelfGet: function (options) {
            return exports.ProfileApiFp(configuration).apiV1ProfilesSelfGet(options)(axios, basePath);
        },
        /**
         *
         * @summary Creates or updates the profile icon
         * @param {ChangeProfilePicture} [changeProfilePicture]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesSelfIconPut: function (changeProfilePicture, options) {
            return exports.ProfileApiFp(configuration).apiV1ProfilesSelfIconPut(changeProfilePicture, options)(axios, basePath);
        },
        /**
         *
         * @summary Creates or updates the profile logo
         * @param {ChangeProfilePicture} [changeProfilePicture]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProfilesSelfLogoPut: function (changeProfilePicture, options) {
            return exports.ProfileApiFp(configuration).apiV1ProfilesSelfLogoPut(changeProfilePicture, options)(axios, basePath);
        },
        /**
         *
         * @summary Returns entire profile by user name with list of allowed actors overall.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserProfilesGet: function (options) {
            return exports.ProfileApiFp(configuration).apiV1UserProfilesGet(options)(axios, basePath);
        },
        /**
         *
         * @summary Returns user context by user id with list of allowed actors overall.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserUsercontextGet: function (options) {
            return exports.ProfileApiFp(configuration).apiV1UserUsercontextGet(options)(axios, basePath);
        },
    };
};
/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
var ProfileApi = /** @class */ (function (_super) {
    __extends(ProfileApi, _super);
    function ProfileApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Return a list of allowed actors within the context of profile [profileKey].
     * @param {string} profileKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    ProfileApi.prototype.apiV1ActorsByProfileKeyGet = function (profileKey, options) {
        return exports.ProfileApiFp(this.configuration).apiV1ActorsByProfileKeyGet(profileKey, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returns list of allowed actors overall
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    ProfileApi.prototype.apiV1ActorsGet = function (options) {
        return exports.ProfileApiFp(this.configuration).apiV1ActorsGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get profile by id
     * @param {string} id2
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    ProfileApi.prototype.apiV1ProfilesByIdGet = function (id2, id, options) {
        return exports.ProfileApiFp(this.configuration).apiV1ProfilesByIdGet(id2, id, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Retunrs the icon image for provided profileId
     * @param {number} profileId
     * @param {string} [cacheKey]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    ProfileApi.prototype.apiV1ProfilesByProfileIdIconGet = function (profileId, cacheKey, options) {
        return exports.ProfileApiFp(this.configuration).apiV1ProfilesByProfileIdIconGet(profileId, cacheKey, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Retunrs the logo image for provided profileId
     * @param {number} profileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    ProfileApi.prototype.apiV1ProfilesByProfileIdLogoGet = function (profileId, options) {
        return exports.ProfileApiFp(this.configuration).apiV1ProfilesByProfileIdLogoGet(profileId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returns actors of logged in user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    ProfileApi.prototype.apiV1ProfilesSelfActorsGet = function (options) {
        return exports.ProfileApiFp(this.configuration).apiV1ProfilesSelfActorsGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returns a full profile of logged in user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    ProfileApi.prototype.apiV1ProfilesSelfGet = function (options) {
        return exports.ProfileApiFp(this.configuration).apiV1ProfilesSelfGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Creates or updates the profile icon
     * @param {ChangeProfilePicture} [changeProfilePicture]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    ProfileApi.prototype.apiV1ProfilesSelfIconPut = function (changeProfilePicture, options) {
        return exports.ProfileApiFp(this.configuration).apiV1ProfilesSelfIconPut(changeProfilePicture, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Creates or updates the profile logo
     * @param {ChangeProfilePicture} [changeProfilePicture]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    ProfileApi.prototype.apiV1ProfilesSelfLogoPut = function (changeProfilePicture, options) {
        return exports.ProfileApiFp(this.configuration).apiV1ProfilesSelfLogoPut(changeProfilePicture, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returns entire profile by user name with list of allowed actors overall.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    ProfileApi.prototype.apiV1UserProfilesGet = function (options) {
        return exports.ProfileApiFp(this.configuration).apiV1UserProfilesGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returns user context by user id with list of allowed actors overall.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    ProfileApi.prototype.apiV1UserUsercontextGet = function (options) {
        return exports.ProfileApiFp(this.configuration).apiV1UserUsercontextGet(options)(this.axios, this.basePath);
    };
    return ProfileApi;
}(base_1.BaseAPI));
exports.ProfileApi = ProfileApi;
/**
 * ProfileNotificationsApi - axios parameter creator
 * @export
 */
exports.ProfileNotificationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returning list of notifications.
         * @param {string} notificationKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsByNotificationKeyEmailGet: function (notificationKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'notificationKey' is not null or undefined
            if (notificationKey === null || notificationKey === undefined) {
                throw new base_1.RequiredError('notificationKey', 'Required parameter notificationKey was null or undefined when calling apiV1NotificationsByNotificationKeyEmailGet.');
            }
            var localVarPath = "/api/v1/notifications/{notificationKey}/email"
                .replace("{" + "notificationKey" + "}", encodeURIComponent(String(notificationKey)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returning paged list of notifications.
         * @param {boolean} [isRead]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsGet: function (isRead, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/notifications";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (isRead !== undefined) {
                localVarQueryParameter['isRead'] = isRead;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProfileNotificationsApi - functional programming interface
 * @export
 */
exports.ProfileNotificationsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Returning list of notifications.
         * @param {string} notificationKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsByNotificationKeyEmailGet: function (notificationKey, options) {
            var localVarAxiosArgs = exports.ProfileNotificationsApiAxiosParamCreator(configuration).apiV1NotificationsByNotificationKeyEmailGet(notificationKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returning paged list of notifications.
         * @param {boolean} [isRead]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsGet: function (isRead, offset, limit, options) {
            var localVarAxiosArgs = exports.ProfileNotificationsApiAxiosParamCreator(configuration).apiV1NotificationsGet(isRead, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ProfileNotificationsApi - factory interface
 * @export
 */
exports.ProfileNotificationsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Returning list of notifications.
         * @param {string} notificationKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsByNotificationKeyEmailGet: function (notificationKey, options) {
            return exports.ProfileNotificationsApiFp(configuration).apiV1NotificationsByNotificationKeyEmailGet(notificationKey, options)(axios, basePath);
        },
        /**
         *
         * @summary Returning paged list of notifications.
         * @param {boolean} [isRead]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NotificationsGet: function (isRead, offset, limit, options) {
            return exports.ProfileNotificationsApiFp(configuration).apiV1NotificationsGet(isRead, offset, limit, options)(axios, basePath);
        },
    };
};
/**
 * ProfileNotificationsApi - object-oriented interface
 * @export
 * @class ProfileNotificationsApi
 * @extends {BaseAPI}
 */
var ProfileNotificationsApi = /** @class */ (function (_super) {
    __extends(ProfileNotificationsApi, _super);
    function ProfileNotificationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Returning list of notifications.
     * @param {string} notificationKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileNotificationsApi
     */
    ProfileNotificationsApi.prototype.apiV1NotificationsByNotificationKeyEmailGet = function (notificationKey, options) {
        return exports.ProfileNotificationsApiFp(this.configuration).apiV1NotificationsByNotificationKeyEmailGet(notificationKey, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returning paged list of notifications.
     * @param {boolean} [isRead]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileNotificationsApi
     */
    ProfileNotificationsApi.prototype.apiV1NotificationsGet = function (isRead, offset, limit, options) {
        return exports.ProfileNotificationsApiFp(this.configuration).apiV1NotificationsGet(isRead, offset, limit, options)(this.axios, this.basePath);
    };
    return ProfileNotificationsApi;
}(base_1.BaseAPI));
exports.ProfileNotificationsApi = ProfileNotificationsApi;
/**
 * ProfileSettingsApi - axios parameter creator
 * @export
 */
exports.ProfileSettingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete connect token for current user.
         * @param {string} connectionType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsConnectByConnectionTypeDelete: function (connectionType, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'connectionType' is not null or undefined
            if (connectionType === null || connectionType === undefined) {
                throw new base_1.RequiredError('connectionType', 'Required parameter connectionType was null or undefined when calling apiV1SettingsConnectByConnectionTypeDelete.');
            }
            var localVarPath = "/api/v1/settings/connect/{connectionType}"
                .replace("{" + "connectionType" + "}", encodeURIComponent(String(connectionType)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get connect token of current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsConnectGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/settings/connect";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create or update connect token for current user.
         * @param {ParticipantExternalConnectionsResource} [connection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsConnectPut: function (connection, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/settings/connect";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof connection !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(connection !== undefined ? connection : {}) : (connection || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get profile settings of current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsGeneralGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/settings/general";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create or update general settings for current user.
         * @param {GeneralSettingsResource} [generalSettingsResource]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsGeneralPut: function (generalSettingsResource, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/settings/general";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof generalSettingsResource !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(generalSettingsResource !== undefined ? generalSettingsResource : {}) : (generalSettingsResource || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all settings of current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/settings";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get notification settings of current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsNotificationsGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/settings/notifications";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create or update notification settings for current user.
         * @param {NotificationSettingsResource} [notificationResource]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsNotificationsPut: function (notificationResource, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/settings/notifications";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof notificationResource !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(notificationResource !== undefined ? notificationResource : {}) : (notificationResource || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all settings of current user.
         * @param {ProfileSettingsResource} [profileSettingsResource]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsPut: function (profileSettingsResource, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/settings";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof profileSettingsResource !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(profileSettingsResource !== undefined ? profileSettingsResource : {}) : (profileSettingsResource || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProfileSettingsApi - functional programming interface
 * @export
 */
exports.ProfileSettingsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Delete connect token for current user.
         * @param {string} connectionType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsConnectByConnectionTypeDelete: function (connectionType, options) {
            var localVarAxiosArgs = exports.ProfileSettingsApiAxiosParamCreator(configuration).apiV1SettingsConnectByConnectionTypeDelete(connectionType, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get connect token of current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsConnectGet: function (options) {
            var localVarAxiosArgs = exports.ProfileSettingsApiAxiosParamCreator(configuration).apiV1SettingsConnectGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Create or update connect token for current user.
         * @param {ParticipantExternalConnectionsResource} [connection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsConnectPut: function (connection, options) {
            var localVarAxiosArgs = exports.ProfileSettingsApiAxiosParamCreator(configuration).apiV1SettingsConnectPut(connection, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get profile settings of current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsGeneralGet: function (options) {
            var localVarAxiosArgs = exports.ProfileSettingsApiAxiosParamCreator(configuration).apiV1SettingsGeneralGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Create or update general settings for current user.
         * @param {GeneralSettingsResource} [generalSettingsResource]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsGeneralPut: function (generalSettingsResource, options) {
            var localVarAxiosArgs = exports.ProfileSettingsApiAxiosParamCreator(configuration).apiV1SettingsGeneralPut(generalSettingsResource, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all settings of current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsGet: function (options) {
            var localVarAxiosArgs = exports.ProfileSettingsApiAxiosParamCreator(configuration).apiV1SettingsGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get notification settings of current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsNotificationsGet: function (options) {
            var localVarAxiosArgs = exports.ProfileSettingsApiAxiosParamCreator(configuration).apiV1SettingsNotificationsGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Create or update notification settings for current user.
         * @param {NotificationSettingsResource} [notificationResource]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsNotificationsPut: function (notificationResource, options) {
            var localVarAxiosArgs = exports.ProfileSettingsApiAxiosParamCreator(configuration).apiV1SettingsNotificationsPut(notificationResource, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all settings of current user.
         * @param {ProfileSettingsResource} [profileSettingsResource]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsPut: function (profileSettingsResource, options) {
            var localVarAxiosArgs = exports.ProfileSettingsApiAxiosParamCreator(configuration).apiV1SettingsPut(profileSettingsResource, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ProfileSettingsApi - factory interface
 * @export
 */
exports.ProfileSettingsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Delete connect token for current user.
         * @param {string} connectionType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsConnectByConnectionTypeDelete: function (connectionType, options) {
            return exports.ProfileSettingsApiFp(configuration).apiV1SettingsConnectByConnectionTypeDelete(connectionType, options)(axios, basePath);
        },
        /**
         *
         * @summary Get connect token of current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsConnectGet: function (options) {
            return exports.ProfileSettingsApiFp(configuration).apiV1SettingsConnectGet(options)(axios, basePath);
        },
        /**
         *
         * @summary Create or update connect token for current user.
         * @param {ParticipantExternalConnectionsResource} [connection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsConnectPut: function (connection, options) {
            return exports.ProfileSettingsApiFp(configuration).apiV1SettingsConnectPut(connection, options)(axios, basePath);
        },
        /**
         *
         * @summary Get profile settings of current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsGeneralGet: function (options) {
            return exports.ProfileSettingsApiFp(configuration).apiV1SettingsGeneralGet(options)(axios, basePath);
        },
        /**
         *
         * @summary Create or update general settings for current user.
         * @param {GeneralSettingsResource} [generalSettingsResource]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsGeneralPut: function (generalSettingsResource, options) {
            return exports.ProfileSettingsApiFp(configuration).apiV1SettingsGeneralPut(generalSettingsResource, options)(axios, basePath);
        },
        /**
         *
         * @summary Get all settings of current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsGet: function (options) {
            return exports.ProfileSettingsApiFp(configuration).apiV1SettingsGet(options)(axios, basePath);
        },
        /**
         *
         * @summary Get notification settings of current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsNotificationsGet: function (options) {
            return exports.ProfileSettingsApiFp(configuration).apiV1SettingsNotificationsGet(options)(axios, basePath);
        },
        /**
         *
         * @summary Create or update notification settings for current user.
         * @param {NotificationSettingsResource} [notificationResource]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsNotificationsPut: function (notificationResource, options) {
            return exports.ProfileSettingsApiFp(configuration).apiV1SettingsNotificationsPut(notificationResource, options)(axios, basePath);
        },
        /**
         *
         * @summary Get all settings of current user.
         * @param {ProfileSettingsResource} [profileSettingsResource]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SettingsPut: function (profileSettingsResource, options) {
            return exports.ProfileSettingsApiFp(configuration).apiV1SettingsPut(profileSettingsResource, options)(axios, basePath);
        },
    };
};
/**
 * ProfileSettingsApi - object-oriented interface
 * @export
 * @class ProfileSettingsApi
 * @extends {BaseAPI}
 */
var ProfileSettingsApi = /** @class */ (function (_super) {
    __extends(ProfileSettingsApi, _super);
    function ProfileSettingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete connect token for current user.
     * @param {string} connectionType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileSettingsApi
     */
    ProfileSettingsApi.prototype.apiV1SettingsConnectByConnectionTypeDelete = function (connectionType, options) {
        return exports.ProfileSettingsApiFp(this.configuration).apiV1SettingsConnectByConnectionTypeDelete(connectionType, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get connect token of current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileSettingsApi
     */
    ProfileSettingsApi.prototype.apiV1SettingsConnectGet = function (options) {
        return exports.ProfileSettingsApiFp(this.configuration).apiV1SettingsConnectGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Create or update connect token for current user.
     * @param {ParticipantExternalConnectionsResource} [connection]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileSettingsApi
     */
    ProfileSettingsApi.prototype.apiV1SettingsConnectPut = function (connection, options) {
        return exports.ProfileSettingsApiFp(this.configuration).apiV1SettingsConnectPut(connection, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get profile settings of current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileSettingsApi
     */
    ProfileSettingsApi.prototype.apiV1SettingsGeneralGet = function (options) {
        return exports.ProfileSettingsApiFp(this.configuration).apiV1SettingsGeneralGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Create or update general settings for current user.
     * @param {GeneralSettingsResource} [generalSettingsResource]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileSettingsApi
     */
    ProfileSettingsApi.prototype.apiV1SettingsGeneralPut = function (generalSettingsResource, options) {
        return exports.ProfileSettingsApiFp(this.configuration).apiV1SettingsGeneralPut(generalSettingsResource, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get all settings of current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileSettingsApi
     */
    ProfileSettingsApi.prototype.apiV1SettingsGet = function (options) {
        return exports.ProfileSettingsApiFp(this.configuration).apiV1SettingsGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get notification settings of current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileSettingsApi
     */
    ProfileSettingsApi.prototype.apiV1SettingsNotificationsGet = function (options) {
        return exports.ProfileSettingsApiFp(this.configuration).apiV1SettingsNotificationsGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Create or update notification settings for current user.
     * @param {NotificationSettingsResource} [notificationResource]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileSettingsApi
     */
    ProfileSettingsApi.prototype.apiV1SettingsNotificationsPut = function (notificationResource, options) {
        return exports.ProfileSettingsApiFp(this.configuration).apiV1SettingsNotificationsPut(notificationResource, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get all settings of current user.
     * @param {ProfileSettingsResource} [profileSettingsResource]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileSettingsApi
     */
    ProfileSettingsApi.prototype.apiV1SettingsPut = function (profileSettingsResource, options) {
        return exports.ProfileSettingsApiFp(this.configuration).apiV1SettingsPut(profileSettingsResource, options)(this.axios, this.basePath);
    };
    return ProfileSettingsApi;
}(base_1.BaseAPI));
exports.ProfileSettingsApi = ProfileSettingsApi;
/**
 * RecipesApi - axios parameter creator
 * @export
 */
exports.RecipesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {Array<RecipeRes>} [recipes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesByCreatorLegalIsoIdentifierPost: function (creatorLegalIsoIdentifier, recipes, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'creatorLegalIsoIdentifier' is not null or undefined
            if (creatorLegalIsoIdentifier === null || creatorLegalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('creatorLegalIsoIdentifier', 'Required parameter creatorLegalIsoIdentifier was null or undefined when calling apiV1RecipesByCreatorLegalIsoIdentifierPost.');
            }
            var localVarPath = "/api/v1/recipes/{creatorLegalIsoIdentifier}"
                .replace("{" + "creatorLegalIsoIdentifier" + "}", encodeURIComponent(String(creatorLegalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof recipes !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(recipes !== undefined ? recipes : {}) : (recipes || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost: function (creatorLegalIsoIdentifier, key, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'creatorLegalIsoIdentifier' is not null or undefined
            if (creatorLegalIsoIdentifier === null || creatorLegalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('creatorLegalIsoIdentifier', 'Required parameter creatorLegalIsoIdentifier was null or undefined when calling apiV1RecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost.');
            }
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new base_1.RequiredError('key', 'Required parameter key was null or undefined when calling apiV1RecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost.');
            }
            var localVarPath = "/api/v1/recipes/{creatorLegalIsoIdentifier}/recipe-batches/{key}/mark-imported"
                .replace("{" + "creatorLegalIsoIdentifier" + "}", encodeURIComponent(String(creatorLegalIsoIdentifier)))
                .replace("{" + "key" + "}", encodeURIComponent(String(key)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [action]
         * @param {string} [status]
         * @param {Date} [from]
         * @param {Date} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesGet: function (action, status, from, to, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/recipes";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesRecipeBatchesByKeyDelete: function (key, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new base_1.RequiredError('key', 'Required parameter key was null or undefined when calling apiV1RecipesRecipeBatchesByKeyDelete.');
            }
            var localVarPath = "/api/v1/recipes/recipe-batches/{key}"
                .replace("{" + "key" + "}", encodeURIComponent(String(key)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesRecipeBatchesByKeyGet: function (key, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new base_1.RequiredError('key', 'Required parameter key was null or undefined when calling apiV1RecipesRecipeBatchesByKeyGet.');
            }
            var localVarPath = "/api/v1/recipes/recipe-batches/{key}"
                .replace("{" + "key" + "}", encodeURIComponent(String(key)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesRelatedCompaniesGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/recipes/related-companies";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RecipesApi - functional programming interface
 * @export
 */
exports.RecipesApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {Array<RecipeRes>} [recipes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesByCreatorLegalIsoIdentifierPost: function (creatorLegalIsoIdentifier, recipes, options) {
            var localVarAxiosArgs = exports.RecipesApiAxiosParamCreator(configuration).apiV1RecipesByCreatorLegalIsoIdentifierPost(creatorLegalIsoIdentifier, recipes, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost: function (creatorLegalIsoIdentifier, key, options) {
            var localVarAxiosArgs = exports.RecipesApiAxiosParamCreator(configuration).apiV1RecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost(creatorLegalIsoIdentifier, key, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} [action]
         * @param {string} [status]
         * @param {Date} [from]
         * @param {Date} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesGet: function (action, status, from, to, options) {
            var localVarAxiosArgs = exports.RecipesApiAxiosParamCreator(configuration).apiV1RecipesGet(action, status, from, to, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesRecipeBatchesByKeyDelete: function (key, options) {
            var localVarAxiosArgs = exports.RecipesApiAxiosParamCreator(configuration).apiV1RecipesRecipeBatchesByKeyDelete(key, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesRecipeBatchesByKeyGet: function (key, options) {
            var localVarAxiosArgs = exports.RecipesApiAxiosParamCreator(configuration).apiV1RecipesRecipeBatchesByKeyGet(key, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesRelatedCompaniesGet: function (options) {
            var localVarAxiosArgs = exports.RecipesApiAxiosParamCreator(configuration).apiV1RecipesRelatedCompaniesGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * RecipesApi - factory interface
 * @export
 */
exports.RecipesApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {Array<RecipeRes>} [recipes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesByCreatorLegalIsoIdentifierPost: function (creatorLegalIsoIdentifier, recipes, options) {
            return exports.RecipesApiFp(configuration).apiV1RecipesByCreatorLegalIsoIdentifierPost(creatorLegalIsoIdentifier, recipes, options)(axios, basePath);
        },
        /**
         *
         * @param {string} creatorLegalIsoIdentifier
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost: function (creatorLegalIsoIdentifier, key, options) {
            return exports.RecipesApiFp(configuration).apiV1RecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost(creatorLegalIsoIdentifier, key, options)(axios, basePath);
        },
        /**
         *
         * @param {string} [action]
         * @param {string} [status]
         * @param {Date} [from]
         * @param {Date} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesGet: function (action, status, from, to, options) {
            return exports.RecipesApiFp(configuration).apiV1RecipesGet(action, status, from, to, options)(axios, basePath);
        },
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesRecipeBatchesByKeyDelete: function (key, options) {
            return exports.RecipesApiFp(configuration).apiV1RecipesRecipeBatchesByKeyDelete(key, options)(axios, basePath);
        },
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesRecipeBatchesByKeyGet: function (key, options) {
            return exports.RecipesApiFp(configuration).apiV1RecipesRecipeBatchesByKeyGet(key, options)(axios, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RecipesRelatedCompaniesGet: function (options) {
            return exports.RecipesApiFp(configuration).apiV1RecipesRelatedCompaniesGet(options)(axios, basePath);
        },
    };
};
/**
 * RecipesApi - object-oriented interface
 * @export
 * @class RecipesApi
 * @extends {BaseAPI}
 */
var RecipesApi = /** @class */ (function (_super) {
    __extends(RecipesApi, _super);
    function RecipesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} creatorLegalIsoIdentifier
     * @param {Array<RecipeRes>} [recipes]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecipesApi
     */
    RecipesApi.prototype.apiV1RecipesByCreatorLegalIsoIdentifierPost = function (creatorLegalIsoIdentifier, recipes, options) {
        return exports.RecipesApiFp(this.configuration).apiV1RecipesByCreatorLegalIsoIdentifierPost(creatorLegalIsoIdentifier, recipes, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} creatorLegalIsoIdentifier
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecipesApi
     */
    RecipesApi.prototype.apiV1RecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost = function (creatorLegalIsoIdentifier, key, options) {
        return exports.RecipesApiFp(this.configuration).apiV1RecipesByCreatorLegalIsoIdentifierRecipeBatchesByKeyMarkImportedPost(creatorLegalIsoIdentifier, key, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} [action]
     * @param {string} [status]
     * @param {Date} [from]
     * @param {Date} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecipesApi
     */
    RecipesApi.prototype.apiV1RecipesGet = function (action, status, from, to, options) {
        return exports.RecipesApiFp(this.configuration).apiV1RecipesGet(action, status, from, to, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecipesApi
     */
    RecipesApi.prototype.apiV1RecipesRecipeBatchesByKeyDelete = function (key, options) {
        return exports.RecipesApiFp(this.configuration).apiV1RecipesRecipeBatchesByKeyDelete(key, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecipesApi
     */
    RecipesApi.prototype.apiV1RecipesRecipeBatchesByKeyGet = function (key, options) {
        return exports.RecipesApiFp(this.configuration).apiV1RecipesRecipeBatchesByKeyGet(key, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecipesApi
     */
    RecipesApi.prototype.apiV1RecipesRelatedCompaniesGet = function (options) {
        return exports.RecipesApiFp(this.configuration).apiV1RecipesRelatedCompaniesGet(options)(this.axios, this.basePath);
    };
    return RecipesApi;
}(base_1.BaseAPI));
exports.RecipesApi = RecipesApi;
/**
 * RequirementsApi - axios parameter creator
 * @export
 */
exports.RequirementsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} partyIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsDelete: function (partyIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partyIdentifier' is not null or undefined
            if (partyIdentifier === null || partyIdentifier === undefined) {
                throw new base_1.RequiredError('partyIdentifier', 'Required parameter partyIdentifier was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsDelete.');
            }
            var localVarPath = "/api/v1/parties/{partyIdentifier}/receiver-requirements"
                .replace("{" + "partyIdentifier" + "}", encodeURIComponent(String(partyIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGet: function (partyIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partyIdentifier' is not null or undefined
            if (partyIdentifier === null || partyIdentifier === undefined) {
                throw new base_1.RequiredError('partyIdentifier', 'Required parameter partyIdentifier was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGet.');
            }
            var localVarPath = "/api/v1/parties/{partyIdentifier}/receiver-requirements"
                .replace("{" + "partyIdentifier" + "}", encodeURIComponent(String(partyIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameDelete: function (partyIdentifier, groupName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partyIdentifier' is not null or undefined
            if (partyIdentifier === null || partyIdentifier === undefined) {
                throw new base_1.RequiredError('partyIdentifier', 'Required parameter partyIdentifier was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameDelete.');
            }
            // verify required parameter 'groupName' is not null or undefined
            if (groupName === null || groupName === undefined) {
                throw new base_1.RequiredError('groupName', 'Required parameter groupName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameDelete.');
            }
            var localVarPath = "/api/v1/parties/{partyIdentifier}/receiver-requirements/groups/{groupName}"
                .replace("{" + "partyIdentifier" + "}", encodeURIComponent(String(partyIdentifier)))
                .replace("{" + "groupName" + "}", encodeURIComponent(String(groupName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} fieldName
         * @param {string} groupName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameDelete: function (partyIdentifier, fieldName, groupName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partyIdentifier' is not null or undefined
            if (partyIdentifier === null || partyIdentifier === undefined) {
                throw new base_1.RequiredError('partyIdentifier', 'Required parameter partyIdentifier was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameDelete.');
            }
            // verify required parameter 'fieldName' is not null or undefined
            if (fieldName === null || fieldName === undefined) {
                throw new base_1.RequiredError('fieldName', 'Required parameter fieldName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameDelete.');
            }
            // verify required parameter 'groupName' is not null or undefined
            if (groupName === null || groupName === undefined) {
                throw new base_1.RequiredError('groupName', 'Required parameter groupName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameDelete.');
            }
            var localVarPath = "/api/v1/parties/{partyIdentifier}/receiver-requirements/groups/{groupName}/fields/{fieldName}"
                .replace("{" + "partyIdentifier" + "}", encodeURIComponent(String(partyIdentifier)))
                .replace("{" + "fieldName" + "}", encodeURIComponent(String(fieldName)))
                .replace("{" + "groupName" + "}", encodeURIComponent(String(groupName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameGet: function (partyIdentifier, groupName, fieldName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partyIdentifier' is not null or undefined
            if (partyIdentifier === null || partyIdentifier === undefined) {
                throw new base_1.RequiredError('partyIdentifier', 'Required parameter partyIdentifier was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameGet.');
            }
            // verify required parameter 'groupName' is not null or undefined
            if (groupName === null || groupName === undefined) {
                throw new base_1.RequiredError('groupName', 'Required parameter groupName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameGet.');
            }
            // verify required parameter 'fieldName' is not null or undefined
            if (fieldName === null || fieldName === undefined) {
                throw new base_1.RequiredError('fieldName', 'Required parameter fieldName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameGet.');
            }
            var localVarPath = "/api/v1/parties/{partyIdentifier}/receiver-requirements/groups/{groupName}/fields/{fieldName}"
                .replace("{" + "partyIdentifier" + "}", encodeURIComponent(String(partyIdentifier)))
                .replace("{" + "groupName" + "}", encodeURIComponent(String(groupName)))
                .replace("{" + "fieldName" + "}", encodeURIComponent(String(fieldName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {RequirementFieldInput} [requirementFieldInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNamePut: function (partyIdentifier, groupName, fieldName, requirementFieldInput, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partyIdentifier' is not null or undefined
            if (partyIdentifier === null || partyIdentifier === undefined) {
                throw new base_1.RequiredError('partyIdentifier', 'Required parameter partyIdentifier was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNamePut.');
            }
            // verify required parameter 'groupName' is not null or undefined
            if (groupName === null || groupName === undefined) {
                throw new base_1.RequiredError('groupName', 'Required parameter groupName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNamePut.');
            }
            // verify required parameter 'fieldName' is not null or undefined
            if (fieldName === null || fieldName === undefined) {
                throw new base_1.RequiredError('fieldName', 'Required parameter fieldName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNamePut.');
            }
            var localVarPath = "/api/v1/parties/{partyIdentifier}/receiver-requirements/groups/{groupName}/fields/{fieldName}"
                .replace("{" + "partyIdentifier" + "}", encodeURIComponent(String(partyIdentifier)))
                .replace("{" + "groupName" + "}", encodeURIComponent(String(groupName)))
                .replace("{" + "fieldName" + "}", encodeURIComponent(String(fieldName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof requirementFieldInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requirementFieldInput !== undefined ? requirementFieldInput : {}) : (requirementFieldInput || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {string} keyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesByKeyNameDelete: function (partyIdentifier, groupName, fieldName, keyName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partyIdentifier' is not null or undefined
            if (partyIdentifier === null || partyIdentifier === undefined) {
                throw new base_1.RequiredError('partyIdentifier', 'Required parameter partyIdentifier was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesByKeyNameDelete.');
            }
            // verify required parameter 'groupName' is not null or undefined
            if (groupName === null || groupName === undefined) {
                throw new base_1.RequiredError('groupName', 'Required parameter groupName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesByKeyNameDelete.');
            }
            // verify required parameter 'fieldName' is not null or undefined
            if (fieldName === null || fieldName === undefined) {
                throw new base_1.RequiredError('fieldName', 'Required parameter fieldName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesByKeyNameDelete.');
            }
            // verify required parameter 'keyName' is not null or undefined
            if (keyName === null || keyName === undefined) {
                throw new base_1.RequiredError('keyName', 'Required parameter keyName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesByKeyNameDelete.');
            }
            var localVarPath = "/api/v1/parties/{partyIdentifier}/receiver-requirements/groups/{groupName}/fields/{fieldName}/values/{keyName}"
                .replace("{" + "partyIdentifier" + "}", encodeURIComponent(String(partyIdentifier)))
                .replace("{" + "groupName" + "}", encodeURIComponent(String(groupName)))
                .replace("{" + "fieldName" + "}", encodeURIComponent(String(fieldName)))
                .replace("{" + "keyName" + "}", encodeURIComponent(String(keyName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesDelete: function (partyIdentifier, groupName, fieldName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partyIdentifier' is not null or undefined
            if (partyIdentifier === null || partyIdentifier === undefined) {
                throw new base_1.RequiredError('partyIdentifier', 'Required parameter partyIdentifier was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesDelete.');
            }
            // verify required parameter 'groupName' is not null or undefined
            if (groupName === null || groupName === undefined) {
                throw new base_1.RequiredError('groupName', 'Required parameter groupName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesDelete.');
            }
            // verify required parameter 'fieldName' is not null or undefined
            if (fieldName === null || fieldName === undefined) {
                throw new base_1.RequiredError('fieldName', 'Required parameter fieldName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesDelete.');
            }
            var localVarPath = "/api/v1/parties/{partyIdentifier}/receiver-requirements/groups/{groupName}/fields/{fieldName}/values"
                .replace("{" + "partyIdentifier" + "}", encodeURIComponent(String(partyIdentifier)))
                .replace("{" + "groupName" + "}", encodeURIComponent(String(groupName)))
                .replace("{" + "fieldName" + "}", encodeURIComponent(String(fieldName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesGet: function (partyIdentifier, groupName, fieldName, offset, limit, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partyIdentifier' is not null or undefined
            if (partyIdentifier === null || partyIdentifier === undefined) {
                throw new base_1.RequiredError('partyIdentifier', 'Required parameter partyIdentifier was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesGet.');
            }
            // verify required parameter 'groupName' is not null or undefined
            if (groupName === null || groupName === undefined) {
                throw new base_1.RequiredError('groupName', 'Required parameter groupName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesGet.');
            }
            // verify required parameter 'fieldName' is not null or undefined
            if (fieldName === null || fieldName === undefined) {
                throw new base_1.RequiredError('fieldName', 'Required parameter fieldName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesGet.');
            }
            var localVarPath = "/api/v1/parties/{partyIdentifier}/receiver-requirements/groups/{groupName}/fields/{fieldName}/values"
                .replace("{" + "partyIdentifier" + "}", encodeURIComponent(String(partyIdentifier)))
                .replace("{" + "groupName" + "}", encodeURIComponent(String(groupName)))
                .replace("{" + "fieldName" + "}", encodeURIComponent(String(fieldName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {Array<RequirementValueInput>} [requirementValues]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesPut: function (partyIdentifier, groupName, fieldName, requirementValues, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partyIdentifier' is not null or undefined
            if (partyIdentifier === null || partyIdentifier === undefined) {
                throw new base_1.RequiredError('partyIdentifier', 'Required parameter partyIdentifier was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesPut.');
            }
            // verify required parameter 'groupName' is not null or undefined
            if (groupName === null || groupName === undefined) {
                throw new base_1.RequiredError('groupName', 'Required parameter groupName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesPut.');
            }
            // verify required parameter 'fieldName' is not null or undefined
            if (fieldName === null || fieldName === undefined) {
                throw new base_1.RequiredError('fieldName', 'Required parameter fieldName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesPut.');
            }
            var localVarPath = "/api/v1/parties/{partyIdentifier}/receiver-requirements/groups/{groupName}/fields/{fieldName}/values"
                .replace("{" + "partyIdentifier" + "}", encodeURIComponent(String(partyIdentifier)))
                .replace("{" + "groupName" + "}", encodeURIComponent(String(groupName)))
                .replace("{" + "fieldName" + "}", encodeURIComponent(String(fieldName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof requirementValues !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requirementValues !== undefined ? requirementValues : {}) : (requirementValues || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {RequirementFieldInput} [requirementFieldInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsPost: function (partyIdentifier, groupName, requirementFieldInput, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partyIdentifier' is not null or undefined
            if (partyIdentifier === null || partyIdentifier === undefined) {
                throw new base_1.RequiredError('partyIdentifier', 'Required parameter partyIdentifier was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsPost.');
            }
            // verify required parameter 'groupName' is not null or undefined
            if (groupName === null || groupName === undefined) {
                throw new base_1.RequiredError('groupName', 'Required parameter groupName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsPost.');
            }
            var localVarPath = "/api/v1/parties/{partyIdentifier}/receiver-requirements/groups/{groupName}/fields"
                .replace("{" + "partyIdentifier" + "}", encodeURIComponent(String(partyIdentifier)))
                .replace("{" + "groupName" + "}", encodeURIComponent(String(groupName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof requirementFieldInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requirementFieldInput !== undefined ? requirementFieldInput : {}) : (requirementFieldInput || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameGet: function (partyIdentifier, groupName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partyIdentifier' is not null or undefined
            if (partyIdentifier === null || partyIdentifier === undefined) {
                throw new base_1.RequiredError('partyIdentifier', 'Required parameter partyIdentifier was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameGet.');
            }
            // verify required parameter 'groupName' is not null or undefined
            if (groupName === null || groupName === undefined) {
                throw new base_1.RequiredError('groupName', 'Required parameter groupName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameGet.');
            }
            var localVarPath = "/api/v1/parties/{partyIdentifier}/receiver-requirements/groups/{groupName}"
                .replace("{" + "partyIdentifier" + "}", encodeURIComponent(String(partyIdentifier)))
                .replace("{" + "groupName" + "}", encodeURIComponent(String(groupName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {RequirementGroupInput} [requirementGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNamePut: function (partyIdentifier, groupName, requirementGroup, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partyIdentifier' is not null or undefined
            if (partyIdentifier === null || partyIdentifier === undefined) {
                throw new base_1.RequiredError('partyIdentifier', 'Required parameter partyIdentifier was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNamePut.');
            }
            // verify required parameter 'groupName' is not null or undefined
            if (groupName === null || groupName === undefined) {
                throw new base_1.RequiredError('groupName', 'Required parameter groupName was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNamePut.');
            }
            var localVarPath = "/api/v1/parties/{partyIdentifier}/receiver-requirements/groups/{groupName}"
                .replace("{" + "partyIdentifier" + "}", encodeURIComponent(String(partyIdentifier)))
                .replace("{" + "groupName" + "}", encodeURIComponent(String(groupName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof requirementGroup !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requirementGroup !== undefined ? requirementGroup : {}) : (requirementGroup || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {RequirementGroupInput} [requirementGroupInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsPost: function (partyIdentifier, requirementGroupInput, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'partyIdentifier' is not null or undefined
            if (partyIdentifier === null || partyIdentifier === undefined) {
                throw new base_1.RequiredError('partyIdentifier', 'Required parameter partyIdentifier was null or undefined when calling apiV1PartiesByPartyIdentifierReceiverRequirementsPost.');
            }
            var localVarPath = "/api/v1/parties/{partyIdentifier}/receiver-requirements"
                .replace("{" + "partyIdentifier" + "}", encodeURIComponent(String(partyIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof requirementGroupInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requirementGroupInput !== undefined ? requirementGroupInput : {}) : (requirementGroupInput || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiverRequirementsFieldsAllowedGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/receiver-requirements/fields/allowed";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["workflow-api-v1"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RequirementsApi - functional programming interface
 * @export
 */
exports.RequirementsApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} partyIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsDelete: function (partyIdentifier, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsDelete(partyIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGet: function (partyIdentifier, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGet(partyIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameDelete: function (partyIdentifier, groupName, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameDelete(partyIdentifier, groupName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} fieldName
         * @param {string} groupName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameDelete: function (partyIdentifier, fieldName, groupName, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameDelete(partyIdentifier, fieldName, groupName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameGet: function (partyIdentifier, groupName, fieldName, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameGet(partyIdentifier, groupName, fieldName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {RequirementFieldInput} [requirementFieldInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNamePut: function (partyIdentifier, groupName, fieldName, requirementFieldInput, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNamePut(partyIdentifier, groupName, fieldName, requirementFieldInput, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {string} keyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesByKeyNameDelete: function (partyIdentifier, groupName, fieldName, keyName, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesByKeyNameDelete(partyIdentifier, groupName, fieldName, keyName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesDelete: function (partyIdentifier, groupName, fieldName, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesDelete(partyIdentifier, groupName, fieldName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesGet: function (partyIdentifier, groupName, fieldName, offset, limit, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesGet(partyIdentifier, groupName, fieldName, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {Array<RequirementValueInput>} [requirementValues]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesPut: function (partyIdentifier, groupName, fieldName, requirementValues, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesPut(partyIdentifier, groupName, fieldName, requirementValues, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {RequirementFieldInput} [requirementFieldInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsPost: function (partyIdentifier, groupName, requirementFieldInput, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsPost(partyIdentifier, groupName, requirementFieldInput, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameGet: function (partyIdentifier, groupName, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameGet(partyIdentifier, groupName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {RequirementGroupInput} [requirementGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNamePut: function (partyIdentifier, groupName, requirementGroup, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNamePut(partyIdentifier, groupName, requirementGroup, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {RequirementGroupInput} [requirementGroupInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsPost: function (partyIdentifier, requirementGroupInput, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsPost(partyIdentifier, requirementGroupInput, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiverRequirementsFieldsAllowedGet: function (options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).receiverRequirementsFieldsAllowedGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * RequirementsApi - factory interface
 * @export
 */
exports.RequirementsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {string} partyIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsDelete: function (partyIdentifier, options) {
            return exports.RequirementsApiFp(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsDelete(partyIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGet: function (partyIdentifier, options) {
            return exports.RequirementsApiFp(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGet(partyIdentifier, options)(axios, basePath);
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameDelete: function (partyIdentifier, groupName, options) {
            return exports.RequirementsApiFp(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameDelete(partyIdentifier, groupName, options)(axios, basePath);
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} fieldName
         * @param {string} groupName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameDelete: function (partyIdentifier, fieldName, groupName, options) {
            return exports.RequirementsApiFp(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameDelete(partyIdentifier, fieldName, groupName, options)(axios, basePath);
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameGet: function (partyIdentifier, groupName, fieldName, options) {
            return exports.RequirementsApiFp(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameGet(partyIdentifier, groupName, fieldName, options)(axios, basePath);
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {RequirementFieldInput} [requirementFieldInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNamePut: function (partyIdentifier, groupName, fieldName, requirementFieldInput, options) {
            return exports.RequirementsApiFp(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNamePut(partyIdentifier, groupName, fieldName, requirementFieldInput, options)(axios, basePath);
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {string} keyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesByKeyNameDelete: function (partyIdentifier, groupName, fieldName, keyName, options) {
            return exports.RequirementsApiFp(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesByKeyNameDelete(partyIdentifier, groupName, fieldName, keyName, options)(axios, basePath);
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesDelete: function (partyIdentifier, groupName, fieldName, options) {
            return exports.RequirementsApiFp(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesDelete(partyIdentifier, groupName, fieldName, options)(axios, basePath);
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesGet: function (partyIdentifier, groupName, fieldName, offset, limit, options) {
            return exports.RequirementsApiFp(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesGet(partyIdentifier, groupName, fieldName, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {string} fieldName
         * @param {Array<RequirementValueInput>} [requirementValues]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesPut: function (partyIdentifier, groupName, fieldName, requirementValues, options) {
            return exports.RequirementsApiFp(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesPut(partyIdentifier, groupName, fieldName, requirementValues, options)(axios, basePath);
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {RequirementFieldInput} [requirementFieldInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsPost: function (partyIdentifier, groupName, requirementFieldInput, options) {
            return exports.RequirementsApiFp(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsPost(partyIdentifier, groupName, requirementFieldInput, options)(axios, basePath);
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameGet: function (partyIdentifier, groupName, options) {
            return exports.RequirementsApiFp(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameGet(partyIdentifier, groupName, options)(axios, basePath);
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {string} groupName
         * @param {RequirementGroupInput} [requirementGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNamePut: function (partyIdentifier, groupName, requirementGroup, options) {
            return exports.RequirementsApiFp(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNamePut(partyIdentifier, groupName, requirementGroup, options)(axios, basePath);
        },
        /**
         *
         * @param {string} partyIdentifier
         * @param {RequirementGroupInput} [requirementGroupInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartiesByPartyIdentifierReceiverRequirementsPost: function (partyIdentifier, requirementGroupInput, options) {
            return exports.RequirementsApiFp(configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsPost(partyIdentifier, requirementGroupInput, options)(axios, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiverRequirementsFieldsAllowedGet: function (options) {
            return exports.RequirementsApiFp(configuration).receiverRequirementsFieldsAllowedGet(options)(axios, basePath);
        },
    };
};
/**
 * RequirementsApi - object-oriented interface
 * @export
 * @class RequirementsApi
 * @extends {BaseAPI}
 */
var RequirementsApi = /** @class */ (function (_super) {
    __extends(RequirementsApi, _super);
    function RequirementsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} partyIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.apiV1PartiesByPartyIdentifierReceiverRequirementsDelete = function (partyIdentifier, options) {
        return exports.RequirementsApiFp(this.configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsDelete(partyIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} partyIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.apiV1PartiesByPartyIdentifierReceiverRequirementsGet = function (partyIdentifier, options) {
        return exports.RequirementsApiFp(this.configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGet(partyIdentifier, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} partyIdentifier
     * @param {string} groupName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameDelete = function (partyIdentifier, groupName, options) {
        return exports.RequirementsApiFp(this.configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameDelete(partyIdentifier, groupName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} partyIdentifier
     * @param {string} fieldName
     * @param {string} groupName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameDelete = function (partyIdentifier, fieldName, groupName, options) {
        return exports.RequirementsApiFp(this.configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameDelete(partyIdentifier, fieldName, groupName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} partyIdentifier
     * @param {string} groupName
     * @param {string} fieldName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameGet = function (partyIdentifier, groupName, fieldName, options) {
        return exports.RequirementsApiFp(this.configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameGet(partyIdentifier, groupName, fieldName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} partyIdentifier
     * @param {string} groupName
     * @param {string} fieldName
     * @param {RequirementFieldInput} [requirementFieldInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNamePut = function (partyIdentifier, groupName, fieldName, requirementFieldInput, options) {
        return exports.RequirementsApiFp(this.configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNamePut(partyIdentifier, groupName, fieldName, requirementFieldInput, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} partyIdentifier
     * @param {string} groupName
     * @param {string} fieldName
     * @param {string} keyName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesByKeyNameDelete = function (partyIdentifier, groupName, fieldName, keyName, options) {
        return exports.RequirementsApiFp(this.configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesByKeyNameDelete(partyIdentifier, groupName, fieldName, keyName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} partyIdentifier
     * @param {string} groupName
     * @param {string} fieldName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesDelete = function (partyIdentifier, groupName, fieldName, options) {
        return exports.RequirementsApiFp(this.configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesDelete(partyIdentifier, groupName, fieldName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} partyIdentifier
     * @param {string} groupName
     * @param {string} fieldName
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesGet = function (partyIdentifier, groupName, fieldName, offset, limit, options) {
        return exports.RequirementsApiFp(this.configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesGet(partyIdentifier, groupName, fieldName, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} partyIdentifier
     * @param {string} groupName
     * @param {string} fieldName
     * @param {Array<RequirementValueInput>} [requirementValues]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesPut = function (partyIdentifier, groupName, fieldName, requirementValues, options) {
        return exports.RequirementsApiFp(this.configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsByFieldNameValuesPut(partyIdentifier, groupName, fieldName, requirementValues, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} partyIdentifier
     * @param {string} groupName
     * @param {RequirementFieldInput} [requirementFieldInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsPost = function (partyIdentifier, groupName, requirementFieldInput, options) {
        return exports.RequirementsApiFp(this.configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameFieldsPost(partyIdentifier, groupName, requirementFieldInput, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} partyIdentifier
     * @param {string} groupName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameGet = function (partyIdentifier, groupName, options) {
        return exports.RequirementsApiFp(this.configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNameGet(partyIdentifier, groupName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} partyIdentifier
     * @param {string} groupName
     * @param {RequirementGroupInput} [requirementGroup]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNamePut = function (partyIdentifier, groupName, requirementGroup, options) {
        return exports.RequirementsApiFp(this.configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsGroupsByGroupNamePut(partyIdentifier, groupName, requirementGroup, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} partyIdentifier
     * @param {RequirementGroupInput} [requirementGroupInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.apiV1PartiesByPartyIdentifierReceiverRequirementsPost = function (partyIdentifier, requirementGroupInput, options) {
        return exports.RequirementsApiFp(this.configuration).apiV1PartiesByPartyIdentifierReceiverRequirementsPost(partyIdentifier, requirementGroupInput, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.receiverRequirementsFieldsAllowedGet = function (options) {
        return exports.RequirementsApiFp(this.configuration).receiverRequirementsFieldsAllowedGet(options)(this.axios, this.basePath);
    };
    return RequirementsApi;
}(base_1.BaseAPI));
exports.RequirementsApi = RequirementsApi;
